var Shopify = Shopify || {};
window.HOMTheme = window.HOMTheme || {};

window.HOMTheme.historyState = {
  get(key) {
    return window.history.state?.[key];
  },

  set(key, value) {
    const currentState = window.history.state;
    const state = currentState && typeof currentState === "object" && !Array.isArray(currentState)
      ? currentState
      : {};
    window.history.replaceState({ ...state, [key]: value }, "");
  }
};

/* ======================================================================
   COLLECT ALL SHOPIFY SECTION IDs
   ====================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  const sectionIds = [];
  const sectionElements = document.querySelectorAll('[id^="shopify-section-"]');

  sectionElements.forEach(section => {
    const fullId = section.id;                        // shopify-section-123456
    const sectionId = fullId.replace('shopify-section-', '');
    sectionIds.push(sectionId);
  });

  // console.log("Loaded all Shopify Sections List:", sectionIds);
});






/* ======================================================================
   Search POPUP OPEN CODE
   ====================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const openBtns = document.querySelectorAll(".search-drawer_popup");
  const closeBtn = document.querySelector(".search_popup_close");
  const popupWrapper = document.querySelector(".search_popup_wrapper");
  const popupInner = popupWrapper
    ? popupWrapper.querySelector(".search_popup_inner")
    : null;
  const searchDrawer = popupInner
    ? popupInner.querySelector("search-drawer")
    : null;

  const html = document.documentElement;
  const body = document.body;

  if (!openBtns.length || !closeBtn || !popupWrapper || !popupInner) return;

  let lastFocusedElement = null;
  const searchHistoryStateKey = "homSearchDrawer";

  function saveSearchState(isOpen = popupWrapper.classList.contains("serach_active")) {
    window.HOMTheme.historyState.set(searchHistoryStateKey, {
      open: isOpen,
      query: searchDrawer?.query || ""
    });
  }

  // Get all focusable elements inside popup
  function getFocusableElements() {
    return Array.from(popupInner.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.offsetParent !== null && !element.closest('[inert]'));
  }

  function openSearchPopup() {
    lastFocusedElement = document.activeElement;
    popupInner.scrollTop = 0;

    // Lock scroll
    html.classList.add("lenis", "lenis-stopped");
    body.setAttribute("data-scroll-locked", "true");

    // Show popup
    popupWrapper.classList.add("serach_active");
    popupWrapper.setAttribute("aria-hidden", "false");
    popupWrapper.removeAttribute("inert");
    saveSearchState(true);

    // Wait for CSS transition / visibility
    requestAnimationFrame(() => {
      if (!popupWrapper.classList.contains("serach_active")) return;
      window.HOMResponsiveMedia.loadInteractionImages(popupWrapper);
      const searchInput = popupInner.querySelector("#search_drawer_input");
      const focusable = getFocusableElements();
      if (searchInput) {
        searchInput.focus();
      } else {
        popupInner.setAttribute("tabindex", "-1");
        popupInner.focus();
      }
    });
  }

  function closeSearchPopup() {
    // Unlock scroll
    html.classList.remove("lenis-stopped");
    body.removeAttribute("data-scroll-locked");

    // Hide popup
    popupWrapper.classList.remove("serach_active");
    popupWrapper.setAttribute("aria-hidden", "true");
    popupWrapper.setAttribute("inert", "");
    saveSearchState(false);

    // Restore focus
    if (lastFocusedElement?.isConnected && lastFocusedElement !== body) {
      lastFocusedElement.focus();
    } else {
      openBtns[0].focus();
    }
  }

  function trapFocus(e) {
    if (!popupWrapper.classList.contains("serach_active")) return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  //  Outside click close (outside INNER only)
  function handleOutsideClick(e) {
    if (
      popupWrapper.classList.contains("serach_active") &&
      !popupInner.contains(e.target) &&
      !Array.from(openBtns).some((button) => button.contains(e.target))
    ) {
      closeSearchPopup();
    }
  }

  // Open popup
  openBtns.forEach((openBtn) => {
    openBtn.addEventListener("click", function (e) {
      e.preventDefault();
      openSearchPopup();
    });
  });

  // Close popup
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeSearchPopup();
  });

  // Keyboard handling
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popupWrapper.classList.contains("serach_active")) {
      closeSearchPopup();
    }
    trapFocus(e);
  });

  // Outside click listeners
  document.addEventListener("mousedown", handleOutsideClick);
  document.addEventListener("touchstart", handleOutsideClick);

  searchDrawer?.addEventListener("search-query-change", () => saveSearchState());

  const savedSearchState = window.HOMTheme.historyState.get(searchHistoryStateKey);
  if (savedSearchState?.open) {
    if (typeof savedSearchState.query === "string") {
      searchDrawer?.restoreQuery(savedSearchState.query);
    }
    openSearchPopup();
  }
});





/* ======================================================================
   ANNOUNCEMENT BAR SLIDER WEB COMPONENT
   ====================================================================== */
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Check if multiple slides exist
    const hasMultipleSlides = this.querySelectorAll(
      ".announcement-bar__item.swiper-slide"
    ).length > 1;

    if (!hasMultipleSlides) return;

    // Read data attributes
    const autoplay = this.dataset.autoplay === "true";
    const speed = parseInt(this.dataset.autoplaySpeed * 1000) || 3000;
    const fade = this.dataset.fade;
    let effect = fade === "true" ? "fade" : "slide";

    // Initialize Swiper
    const swiperContainer = this.querySelector(
      ".announcement-bar__inner.announcement-bar__inner--multiple"
    );

    if (!swiperContainer) return;

    whenSwiperReady(() => {
    new Swiper(swiperContainer, {
      loop: true,
      speed: 1000,
      grabCursor: true,
      autoplay: autoplay
        ? { delay: speed, disableOnInteraction: false }
        : false,
      effect: effect,
      fadeEffect: { crossFade: true },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 1 },
      },
    });
    });
  }
}

// Define custom element
customElements.define("announcement-bar", AnnouncementBar);


/* ======================================================================
    SLIDESHOW SLIDER WEB COMPONENT
   ====================================================================== */
class SlideshowSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       DATA ATTRIBUTES
    ================================ */
    this.sectionId = this.dataset.sectionId || "";
    this.spacing = Number(this.dataset.spacing) || 0;
    this.autoplay = this.dataset.autoplay === "true";
    this.speed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    /* ===========  SELECTORS (UPDATED) ========== */
    this.slider = this.querySelector(
      `.hero-slideshow__slider--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.hero-slideshow__next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.hero-slideshow__prev--${this.sectionId}`
    );

    this.paginationEl = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

  }

  connectedCallback() {
    if (!this.slider) {
      console.warn(
        `Swiper container missing for section: ${this.sectionId}`
      );
      return;
    }

    /* =========== INIT SWIPER ================ */
    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: this.spacing,
        speed: 800,
        effect: this.effect,

        autoplay: this.autoplay
          ? {
              delay: this.speed,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation:
          this.nextBtn && this.prevBtn
            ? {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
              }
            : false,
            
        pagination:
          this.paginationEl
            ? {
                el: this.paginationEl,
                clickable: true,
              }
            : false,
      });
    });
    // console.log(`Swiper initialized for section: ${this.sectionId}`);
  }
  
}

customElements.define("slideshow-slider", SlideshowSlider);




/* ======================================================================
    Collection Slider WEB COMPONENT
   ====================================================================== */


class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.autoplayEnabled = this.dataset.autoplay === "true";
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    this.slider = this.querySelector(".collection_slider_blocks_wrapper");
    this.wrapper = this.querySelector(".swiper-wrapper");
    this.mobileSlides = Number(this.dataset.mobileSlide) || 3;
    this.itemGap = Number(this.dataset.itemGap) || 0;
    this.mobilePeek = 0.35;
    this.swiper = null;
    this.initializing = false;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.slider || !this.wrapper) return;
    this.initSlider();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.initSlider();
  }

  initSlider() {
    if (this.swiper || this.initializing) return; //  prevent double init
    const totalSlides = this.wrapper.children.length;
    const isMobile = window.innerWidth < 1200;

    // Optional: avoid slider init if too few slides
    if (!isMobile && totalSlides < 12) return;

    this.initializing = true;
    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        speed: 800,
        spaceBetween: this.itemGap,
        effect: this.effect,

        //  A11Y FIX — NO LOOP
        loop: false,

        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation: false,
        pagination: false,

        breakpoints: {
          0: { slidesPerView: this.mobileSlides + this.mobilePeek },
          640: { slidesPerView: this.mobileSlides + this.mobilePeek },
          768: { slidesPerView: 5 },
          990: { slidesPerView: 8 },
          1024: { slidesPerView: 8 },
          1200: { slidesPerView: 12 },
          1400: { slidesPerView: 12 },
        },
      });
      this.initializing = false;
    });
  }
}

customElements.define("collection-slider", CollectionSlider);




/* ======================================================================
    Before After WEB COMPONENT
   ====================================================================== */

    try {
    class SectionScaler extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            const vh = window.innerHeight,
                totalSlides = parseInt(this.dataset.totalInners, 10);
            let currentValue = 0,
                targetValue = 0,
                rafId = null;
            const updateInertia = () => {
                    (currentValue += (targetValue - currentValue) * 0.05),
                        this.style.setProperty("--animate-value", currentValue.toFixed(3)),
                        (rafId = requestAnimationFrame(updateInertia));
                },
                handleScroll = () => {
                    const sectionTop = this.offsetTop;
                    let section = (window.scrollY - sectionTop) / vh;
                    (section = Math.max(0, Math.min(section, totalSlides))), (targetValue = section);
                };
            (this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        entry.isIntersecting
                            ? (window.addEventListener("scroll", handleScroll, { passive: !0 }),
                              rafId || (rafId = requestAnimationFrame(updateInertia)))
                            : (window.removeEventListener("scroll", handleScroll),
                              rafId && (cancelAnimationFrame(rafId), (rafId = null)));
                    });
                },
                { root: null, rootMargin: "-10% 0px 0px 0px", threshold: 0 }
            )),
                this.observer.observe(this);
        }
    }
    customElements.get("section-scaler") || customElements.define("section-scaler", SectionScaler);
    } catch (e) {
    console.error(e);
    }
     
    

/* ======================================================================
    Tag Filter Section WEB COMPONENT
   ====================================================================== */
   
class TagFilterCode extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.filterBtn = this.querySelector(
      `#tagFilterBtn-${this.sectionId}`
    );

    this.dropdown1 = this.querySelector(
      `#tagDropdown1-${this.sectionId}`
    );

    this.dropdown2 = this.querySelector(
      `#tagDropdown2-${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.filterBtn || !this.dropdown1 || !this.dropdown2) return;

    this.filterBtn.addEventListener("click", () => {
      const tag1 = this.dropdown1.value;
      const tag2 = this.dropdown2.value;

      if (!tag1 && !tag2) return;

      let url = "/collections/all";

      if (tag1 && tag2) {
        url += `/${tag1}+${tag2}`;
      } else if (tag1) {
        url += `/${tag1}`;
      } else if (tag2) {
        url += `/${tag2}`;
      }

      window.location.href = url;
    });
  }
}

customElements.define("tag-filter-code", TagFilterCode);



/* ======================================================================
    VIDEO  Section WEB COMPONENT
   ====================================================================== */

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.playIcon = this.querySelector(".play_icon_wrapper");

    this.imageContainer = this.querySelector(
      ".video_section_poster_image_wrapper"
    );

    this.videoContainer = this.querySelector(".video_section_video_wrapper");
    this.video = this.videoContainer?.querySelector("video");
    this.iframe = this.videoContainer?.querySelector("iframe");
  }

  connectedCallback() {
    if (this.playIcon && this.imageContainer && this.videoContainer) {
      this.playIcon.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    this.playIcon?.removeEventListener("click", this.handleClick);
  }

  handleClick = () => {
    if (!this.video && !this.iframe) return;

    this.imageContainer.classList.add("nodisp");

    setTimeout(() => {
      this.imageContainer.style.display = "none";
      this.videoContainer.style.display = "block";
      requestAnimationFrame(() => this.videoContainer.classList.add("disp"));

      if (this.video) {
        this.video.play();
      } else if (this.iframe) {
        const src = this.iframe.getAttribute("src");
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (src.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
      }
    }, 500);
  };
}
customElements.define("video-section-block", VideoSection);

/* ======================================================================
    Review Slider Section WEB COMPONENT
   ====================================================================== */

   class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       SECTION ID
    ================================ */
    this.sectionId = this.dataset.sectionId;

    /* ===============================
       SELECTORS (SCOPED)
    ================================ */
    this.slider = this.querySelector(
      `.review_row--${this.sectionId}`
    );

    this.pagination = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.review_buttonNext--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.review_buttonPrev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.slider) return;

  whenSwiperReady(() => {
    this.swiper = new Swiper(this.slider, {
      effect: "cards",
      grabCursor: true,

      cardsEffect: {
        rotate: true,
        perSlideRotate: 4,
        perSlideOffset: 5,
        slideShadows: false,
      },

      pagination: this.pagination
        ? {
            el: this.pagination,
            clickable: true,
          }
        : false,

      navigation:
        this.nextBtn && this.prevBtn
          ? {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn,
            }
          : false,

      initialSlide: 3,
      speed: 500,
    });
    });
  }
}

customElements.define("review-slider", ReviewSlider);


/* ======================================================================
    Product Tab Slider WEB COMPONENT
   ====================================================================== */

  class ProductTabSlider extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.thumbSlider = this.querySelector(
      `.productTab__steps_follow--${this.sectionId}`
    );

    this.mainSlider = this.querySelector(
      `.product_tab_slides--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.productTab_button_next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.productTab_button_prev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.thumbSlider || !this.mainSlider) return;

    whenSwiperReady(() => {
    this.thumbSwiper = new Swiper(this.thumbSlider, {
      spaceBetween: 20,
      slidesPerView: 8,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 15,
        },
      },
    });

    this.mainSwiper = new Swiper(this.mainSlider, {
      spaceBetween: 20,
      slidesPerView: 1,
      centeredSlides: true,
      autoHeight: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
    });
  }
}

customElements.define("product-tab-slider", ProductTabSlider);

   
/* ======================================================================
    Product Recommend filter Section WEB COMPONENT
   ====================================================================== */
  
class TagBasedRecommendation {
  constructor(sectionId) {

    /* ===============================
       DATA
    ================================ */
    this.sectionId = sectionId;
    this.section = document.querySelector(
      `[data-section-id="${sectionId}"]`
    );

    if (!this.section) return;

    /* ===============================
       ELEMENTS
    ================================ */
    this.dropdown1 = this.section.querySelector('[data-tag-dropdown="1"]');
    this.dropdown2 = this.section.querySelector('[data-tag-dropdown="2"]');
    this.button = this.section.querySelector('[data-tag-filter-btn]');

    if (!this.button) return;

    /* ===============================
       EVENTS
    ================================ */
    this.button.addEventListener('click', () => {
      this.handleRedirect();
    });
  }

  handleRedirect() {
    const tag1 = this.dropdown1?.value || '';
    const tag2 = this.dropdown2?.value || '';

    if (!tag1 && !tag2) return;

    let url = '/collections/all';

    if (tag1 && tag2) {
      url += `/${tag1}+${tag2}`;
    } else if (tag1) {
      url += `/${tag1}`;
    } else if (tag2) {
      url += `/${tag2}`;
    }

    window.location.href = url;
  }
}

document.querySelectorAll('[data-section-id]').forEach(section => {
  new TagBasedRecommendation(section.dataset.sectionId);
});

/* ======================================================================
    Product Card Slider Block COMPONENT
   ====================================================================== */

const productCardSliderBindings = new WeakSet();

function initProductCardSliders(scope = document) {
  whenSwiperReady(() => {
    scope.querySelectorAll('[data-product-media-slider], [data-product-media-slider_main]').forEach(card => {
      const element = card.querySelector('.product-card-swiper');
      if (!element || productCardSliderBindings.has(element)) return;
      const slides = Array.from(element.querySelectorAll('.swiper-slide'));
      const previous = card.querySelector('.product-card-prev');
      const next = card.querySelector('.product-card-next');
      const productCard = card.closest('product-card');
      const thumbs = productCard ? Array.from(productCard.querySelectorAll('.product-thumb')) : [];
      const dots = Array.from(card.querySelectorAll('.product-card-media-dot'));
      if (slides.length < 2) {
        [previous, next, ...dots].filter(Boolean).forEach(control => { control.style.display = 'none'; });
        return;
      }
      const swiper = element.swiper || new Swiper(element, {
        effect: 'fade', fadeEffect: { crossFade: true }, speed: 350,
        slidesPerView: 1, allowTouchMove: true,
        nested: Boolean(productCard?.closest('.swiper-slide')),
        touchAngle: 30,
        touchReleaseOnEdges: false, preventClicks: true,
        preventClicksPropagation: true, watchSlidesProgress: true,
        a11y: { enabled: true }, navigation: { prevEl: previous, nextEl: next }
      });
      const bindings = new AbortController();
      productCardSliderBindings.add(element);
      const synchronize = () => {
        const index = swiper.activeIndex;
        window.HOMProductImages.loadSlide(slides[index], { priority: index > 0 ? 'high' : undefined });
        window.HOMProductImages.prefetchCard?.(element, index);
        dots.forEach((dot, position) => {
          dot.classList.toggle('is-active', position === index);
          dot.setAttribute('aria-pressed', String(position === index));
        });
        thumbs.forEach((thumb, position) => {
          thumb.classList.toggle('is-active', position === index);
          thumb.setAttribute('aria-selected', String(position === index));
        });
      };
      const bindSelection = (control, index) => control.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        swiper.slideTo(index);
      }, { signal: bindings.signal });
      dots.forEach(bindSelection);
      thumbs.forEach(thumb => bindSelection(thumb, Number(thumb.dataset.thumbIndex)));
      swiper.on('slideChange activeIndexChange transitionEnd', synchronize);
      swiper.on('destroy', () => {
        bindings.abort();
        window.HOMProductImages.releaseCard?.(element);
        productCardSliderBindings.delete(element);
      });
      synchronize();
    });
  });
}

class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.featured-collection-swiper');
    if (!swiperEl) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const desktop = parseInt(this.dataset.columns, 10) || 4;
    const smallDesktop = parseInt(this.dataset.smallcolumns, 10) || desktop;
    const mobile = parseInt(this.dataset.mobColumns, 10) || 2;
    const visibleDesktop = parseFloat(this.dataset.visibleCards) || desktop;
    const visibleTablet = parseFloat(this.dataset.tabletVisibleCards) || Math.min(3, smallDesktop);
    const visibleMobile = parseFloat(this.dataset.mobileVisibleCards) || mobile;
    const spacing = parseInt(this.dataset.spacing, 10) || 20;

    const paginationEl = this.querySelector('.mobil_swiper-pagination');

    whenSwiperReady(() => {
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: visibleMobile,
        spaceBetween: spacing,
        speed: 600,
        loop: false,
        watchOverflow: false,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,

        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },

        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              enabled: true,
            }
          : false,

        breakpoints: {
          320: {
            // Mobile product cards have an intentional fixed width so the
            // price and cart control remain usable. Measure that real width
            // instead of calculating a smaller fractional slide width.
            slidesPerView: 'auto',
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          768: {
            slidesPerView: visibleTablet,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1024: {
            slidesPerView: visibleDesktop,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1500: {
            slidesPerView: visibleDesktop,
            spaceBetween: spacing,
            allowTouchMove: true,
            pagination: { enabled: true },
          },
        },
      });
    });
  }
}

customElements.define('featured-collection', FeaturedCollection);


/* ======================================================================
   Product Recommendations Component 
   ====================================================================== */


class ProductRecommendations extends HTMLElement {
  constructor({
    repository = new window.HOMSectionRequests.ProductRecommendationRepository(),
    slider = new window.HOMRecommendationSlider.RecommendationSlider(),
    initializeCards = root => initProductCardSliders(root),
    observerFactory = callback => new IntersectionObserver(callback, { rootMargin: '0px 0px 400px 0px' }),
  } = {}) {
    super();
    Object.assign(this, { repository, slider, initializeCards });
    this.observer = observerFactory(entries => {
      if (this.isConnected && entries.some(entry => entry.isIntersecting)) {
        this.observer.disconnect();
        this.loadRecommendedProducts();
      }
    });
    this.onRetry = () => this.loadRecommendedProducts();
  }

  connectedCallback() {
    if (this.loaded) this.renderSlider();
    else if (this.dataset.loadImmediately === 'true') this.loadRecommendedProducts();
    else this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.requestController?.abort();
    this.requestController = null;
    this.loading = false;
    this.setAttribute('aria-busy', 'false');
    cancelAnimationFrame(this.renderFrame);
    this.slider.destroy();
    const retry = this.querySelector('[data-recommendations-retry]');
    if (retry) retry.onclick = null;
  }

  isCurrentRequest(controller) {
    return this.isConnected && !controller.signal.aborted && this.requestController === controller;
  }

  async loadRecommendedProducts() {
    if (this.loading || this.loaded || !this.isConnected) return;
    this.loading = true;
    const controller = new AbortController();
    this.requestController = controller;
    this.setAttribute('aria-busy', 'true');
    const errorState = this.querySelector('[data-recommendations-error]');
    if (errorState) errorState.hidden = true;
    try {
      const result = await this.repository.get({
        url: this.dataset.url, productId: this.dataset.productId, sectionId: this.dataset.sectionId,
        signal: controller.signal, allowEmpty: this.dataset.type === 'complementary-products',
      });
      if (!this.isCurrentRequest(controller)) return;
      this.loaded = true;
      if (result.empty) {
        this.dataset.state = 'empty';
        (this.closest('.product-recommendations-section') || this).hidden = true;
        return;
      }
      this.innerHTML = result.markup;
      this.dataset.state = 'ready';
      this.renderSlider();
      document.dispatchEvent(new CustomEvent('recommended-products-updated'));
    } catch (error) {
      if (!this.isCurrentRequest(controller)) return;
      console.warn('Product recommendations could not be loaded:', error);
      this.dataset.state = 'error';
      if (errorState) errorState.hidden = false;
      const retry = this.querySelector('[data-recommendations-retry]');
      if (retry) retry.onclick = this.onRetry;
    } finally {
      if (this.requestController === controller) {
        this.loading = false;
        this.requestController = null;
        this.setAttribute('aria-busy', 'false');
      }
    }
  }

  renderSlider() {
    if (this.dataset.state !== 'ready') return;
    cancelAnimationFrame(this.renderFrame);
    this.renderFrame = requestAnimationFrame(() => {
      if (!this.isConnected) return;
      this.initializeCards(this);
      this.slider.mount(this, {
        type: this.dataset.type || 'default',
        spacing: Number(this.dataset.spacing) || 20,
        columns: Number(this.dataset.columns) || 4,
        tabletColumns: Number(this.dataset.tabletColumns) || 3,
        mobColumns: Number(this.dataset.mobColumns) || 1,
      });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CartRecommendationRepository {
  constructor({
    fetchImplementation = window.fetch.bind(window),
    origin = window.location.origin
  } = {}) {
    this.fetchImplementation = fetchImplementation;
    this.origin = origin;
  }

  async get({ baseUrl, productId, sectionId, signal }) {
    const url = new URL(baseUrl, this.origin);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('section_id', sectionId);

    const response = await this.fetchImplementation(url, { signal });
    if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
    return response.text();
  }
}

class CartRecommendationRenderer {
  constructor({
    cardInitializer = initProductCardSliders,
    documentTarget = document,
    eventTarget = document
  } = {}) {
    this.cardInitializer = cardInitializer;
    this.documentTarget = documentTarget;
    this.eventTarget = eventTarget;
  }

  render(host, markup) {
    const html = this.documentTarget.createElement('div');
    html.innerHTML = markup;
    const recommendations = html.querySelector('cart-recommendations');
    if (!recommendations?.innerHTML.trim()) return false;

    host.innerHTML = recommendations.innerHTML;
    this.cardInitializer(host);
    this.eventTarget.dispatchEvent(new CustomEvent('recommended-products-updated'));
    return true;
  }
}

class CartRecommendationView {
  connect(host, onRetry) {
    const retry = host.querySelector('[data-recommendations-retry]');
    if (retry) retry.onclick = onRetry;
  }

  disconnect(host) {
    const retry = host.querySelector('[data-recommendations-retry]');
    if (retry) retry.onclick = null;
    host.setAttribute('aria-busy', 'false');
  }

  setState(host, state) {
    host.dataset.state = state;
    host.hidden = state === 'empty';
    host.setAttribute('aria-busy', String(state === 'loading'));
    const errorMessage = host.querySelector('[data-recommendations-error]');
    if (errorMessage) errorMessage.hidden = state !== 'error';
  }
}

class CartRecommendations extends HTMLElement {
  constructor({
    repository = new CartRecommendationRepository(),
    renderer = new CartRecommendationRenderer(),
    view = new CartRecommendationView(),
    observerFactory = (callback) => new IntersectionObserver(callback, { rootMargin: '0px 0px 300px 0px' })
  } = {}) {
    super();
    this.repository = repository;
    this.renderer = renderer;
    this.view = view;
    this.onRetry = () => this.load();
    this.abortController = null;
    this.observer = observerFactory((entries) => this.handleIntersection(entries));
  }

  connectedCallback() {
    this.view.connect(this, this.onRetry);
    if (this.loaded || this.dataset.state === 'ready') return;
    if (!this.dataset.productId || !this.dataset.url || !this.dataset.sectionId) {
      this.view.setState(this, 'empty');
      return;
    }
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.abortController?.abort();
    this.abortController = null;
    this.view.disconnect(this);
  }

  handleIntersection(entries) {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    this.observer.disconnect();
    this.load();
  }

  isCurrentRequest(controller) {
    return this.isConnected && !controller.signal.aborted && this.abortController === controller;
  }

  async load() {
    if (!this.isConnected || this.loaded || this.abortController || this.dataset.state === 'ready') return;
    const controller = new AbortController();
    this.abortController = controller;
    this.view.setState(this, 'loading');

    try {
      const markup = await this.repository.get({
        baseUrl: this.dataset.url,
        productId: this.dataset.productId,
        sectionId: this.dataset.sectionId,
        signal: controller.signal
      });
      if (!this.isCurrentRequest(controller)) return;
      const rendered = this.renderer.render(this, markup);
      this.loaded = true;
      this.view.setState(this, rendered ? 'ready' : 'empty');
    } catch {
      if (!this.isCurrentRequest(controller)) return;
      this.view.setState(this, 'error');
    } finally {
      if (this.abortController === controller) {
        this.abortController = null;
      }
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);





/* ======================================================================
   QuickAdd Component 
   ====================================================================== */


/* ======================== Quick view drawer open code ================== */
function openDrawer(drawerWrapper, triggerBtn) {
  if (!drawerWrapper) return;

  const drawerInner = drawerWrapper.querySelector('.quick_add-wrapper_inner');
  const closeBtn = drawerWrapper.querySelector('.quick_add_drawer_close');

  const focusableSelectors =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  // Save trigger
  drawerWrapper._triggerBtn = triggerBtn;

  /* -----------------------------
     OPEN STATE
  ----------------------------- */
  drawerWrapper.removeAttribute('inert');
  drawerWrapper.setAttribute('aria-hidden', 'false');
  drawerWrapper.classList.add('is-open');
  

  //  Scroll lock
  document.documentElement.classList.add('lenis', 'lenis-stopped');
  document.body.setAttribute('data-scroll-locked', 'true');
  document.body.classList.add('quick-add-open');

  // Focus first focusable (AFTER async content)
  setTimeout(() => {
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    (focusables[0] || drawerInner).focus();
  }, 50);

  /* -----------------------------
     KEYBOARD: ESC + FOCUS TRAP
  ----------------------------- */
  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer(drawerWrapper);
      return;
    }

    if (e.key !== 'Tab') return;

    //  Recalculate every time (fixes async content issue)
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  drawerWrapper.addEventListener('keydown', handleKeydown);
  drawerWrapper._handleKeydown = handleKeydown;

  /* -----------------------------
     OUTSIDE CLICK (INNER PANEL)
  ----------------------------- */
  function handleOutsideClick(e) {
    if (!drawerInner.contains(e.target) && e.target !== triggerBtn) {
      closeDrawer(drawerWrapper);
    }
  }

  setTimeout(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  }, 0);

  drawerWrapper._handleOutsideClick = handleOutsideClick;

  /* -----------------------------
     CLOSE BUTTON
  ----------------------------- */
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeDrawer(drawerWrapper));
  }
}

function closeDrawer(drawerWrapper) {
  if (!drawerWrapper) return;

  drawerWrapper.setAttribute('inert', '');
  drawerWrapper.setAttribute('aria-hidden', 'true');
  drawerWrapper.classList.remove('is-open');
  

  //  Unlock scroll
  document.documentElement.classList.remove('lenis', 'lenis-stopped');
  document.body.removeAttribute('data-scroll-locked');
  document.body.classList.remove('quick-add-open');

  // Cleanup listeners
  if (drawerWrapper._handleKeydown) {
    drawerWrapper.removeEventListener('keydown', drawerWrapper._handleKeydown);
  }

  if (drawerWrapper._handleOutsideClick) {
    document.removeEventListener('mousedown', drawerWrapper._handleOutsideClick);
    document.removeEventListener('touchstart', drawerWrapper._handleOutsideClick);
  }

  // Restore focus
  if (drawerWrapper._triggerBtn) {
    drawerWrapper._triggerBtn.focus();
  }
}



// ========== QUICK ADD CODE ============= //

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.btn = this.querySelector('button');
    this.drawerWrapper = document.querySelector('.quick_add_slide')
    this.drawer = document.querySelector('.quick_add_side_inner');
    this.handleProductFetch = this.handleProductFetch.bind(this);
  }

  connectedCallback() {
    this.attachEventHandler();   
    
  }

  attachEventHandler() {
    if(this._isEventAttached) return;
    if(!this.btn) return;

    this._isEventAttached = true;
    this.btn.addEventListener('click', this.handleProductFetch)
  }

  showSkeleton() {
  this.drawer.innerHTML = `<div class="quick_add_block">Quick View </div>
  `;
}

  handleProductFetch() {
  this.showSkeleton();

  fetch(`${this.productUrl}`)
    .then((res) => res.text())
    .then((htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      const newHTML = div.querySelector('.main_product_main');
      if (!newHTML) return;

      const mainProduct = newHTML.querySelector('main-product-section');

      const originalSectionId = mainProduct.dataset.sectionId;
      const quickAddSectionId = `quick-add-${originalSectionId}`;

      // Replace IDs
      newHTML.innerHTML = newHTML.innerHTML.replaceAll(
        originalSectionId,
        quickAddSectionId
      );

      newHTML.querySelector('main-product-section').dataset.originalSectionId = originalSectionId;
      newHTML.querySelector('main-product-section').dataset.updateUrl = 'false';    
      
      const tabs = newHTML.querySelectorAll('.main_product_collapsible_wrapper');
      if(tabs) {
        tabs.forEach((tab) => {
          tab.remove();
        })
      }

      const pickup = newHTML.querySelector('.main_product_pickup_availability_wrapper');
      if(pickup) {
        pickup.remove();
      }

      const badges_block = newHTML.querySelector('.main_product_badges_block');
      if(badges_block) {
        badges_block.remove();
      }  
      
       const size_block = newHTML.querySelector('.main_product_size_chart');
      if(size_block) {
        size_block.remove();
      } 

      // Inject
      this.drawer.replaceChildren(...newHTML.children);
    });

    openDrawer(this.drawerWrapper, this.btn)
}

}

customElements.define('quick-add-to-cart', QuickAdd);




/* =============== Quick view call back function ================== */

document.addEventListener('collection-grid-update', () => {
  document.querySelectorAll('quick-add-to-cart').forEach((el) => {
    el.attachEventHandler();
  });
});




/* ======================================================================
   GIFT CARD 'recipient-form' Component JS
   ====================================================================== */

if (!customElements.get('recipient-form')) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.checkbox = this.qs(`Recipient_checkbox`);
      this.hiddenControls = this.qs(`Recipient_control`);
      this.wrapper = this.querySelector('.recipients_input_wrapper');
      this.inner = this.wrapper?.querySelector('.recipients_input_inner');

      this.emailInput = this.qs(`Recipient_email`);
      this.nameInput = this.qs(`Recipient_name`);
      this.messageInput = this.qs(`Recipient_message`);
      this.sendonInput = this.qs(`Recipient_send_on`);
      this.offsetProperty = this.qs(`Recipient_timezone_offset`);

      if (this.checkbox) this.checkbox.disabled = false;
      if (this.hiddenControls) this.hiddenControls.disabled = true;

      if (this.offsetProperty) {
        this.offsetProperty.value = new Date().getTimezoneOffset().toString();
      }

      this.addEventListener('change', () => this.toggleWrapper());
    }

    qs(prefix) {
      return this.querySelector(`#${prefix}--${this.sectionId}`);
    }

    connectedCallback() {
      if (!this.inner || !this.wrapper) return;

      const height = this.inner.clientHeight;
      this.wrapper.style.setProperty('--height', `${height}px`);
    }

    toggleWrapper() {
      if (!this.checkbox || !this.wrapper) return;

      this.wrapper.toggleAttribute('open', this.checkbox.checked);
    }
  }

  customElements.define('recipient-form', RecipientForm);
}


/* ======================================================================
   MAIN PRODUCT PAGE Component 
   ====================================================================== */


//  ================= VARIANT PICKER =================
class VariantPicker extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this.selectedOptions = this.getSelectedOptions;
      
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            selectedOptions: this.selectedOptions
          },
          bubbles: true
        })
      )
    })
  }

  get getSelectedOptions() {
      const selectValues = Array.from(this.querySelectorAll('select')).map((select) => {
        return select.selectedOptions[0].dataset.value;
      })

      const radioValues = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => {
        return input.dataset.value;
      })

      return [...selectValues, ...radioValues];
  }
}

customElements.define('variant-picker', VariantPicker);





//  ================= PRODUCT PICKUP DROP-DOWN  =================
document.addEventListener('click', function (e) {
  const toggleBtn = e.target.closest('.accordion_open_btn_pickup');
  if (!toggleBtn) return;

  const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
  const drawer = wrapper?.querySelector('.pickup_availability_drawer');

  if (!wrapper || !drawer) return;

  const isOpen = wrapper.classList.contains('is-open');

  wrapper.classList.toggle('is-open', !isOpen);
  drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
  toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
});


//  ================= QUANTITY PICKER =================
class QuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.cacheElements();
  }

  cacheElements() {
    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn  = this.querySelector('[data-plus]');
    this.addBtn   = this.querySelector('[data-stepper-add]');
    this.inner    = this.querySelector('.quantity_inner');
    this.input    = this.querySelector('input[type="text"]');
  }

  connectedCallback() {
    this.cacheElements();
    if (!this.input) return;

    this.step = Number(this.input.step) || 1;
    this.purchaseMin = Number(this.dataset.purchaseMin) || this.step;
    const minimum = Number(this.input.dataset.min);
    this.min = Number.isFinite(minimum) ? minimum : 1;
    this.max  = this.input.dataset.max ? Number(this.input.dataset.max) : null;

    const initialValue = Number(this.input.value);
    this.value = Number.isFinite(initialValue) ? initialValue : this.min;
    if (!this.input || !this.minusBtn || !this.plusBtn) return;
    if (this.dataset.quantityPickerInitialized === 'true') return;
    this.dataset.quantityPickerInitialized = 'true';

    this.minusBtn.addEventListener('click', () => this.change(-this.step));
    this.plusBtn.addEventListener('click', () => this.change(this.step));
    this.addBtn?.addEventListener('click', () => {
      this.dispatchEvent(
        new CustomEvent('quantity-change', {
          detail: { value: Number(this.dataset.purchaseMin) || 1 },
          bubbles: true
        })
      );
    });

    this.input.addEventListener(
      'input',
      this.debounce(() => {
        this.setValue(Number(this.input.value) || this.min);
      }, 600)
    );

    this.updateButtons();
  }

  /* -------- Value Logic -------- */

  change(amount) {
    if (
      this.dataset.inCart === 'true' &&
      amount < 0 &&
      this.value + amount < this.purchaseMin
    ) {
      this.setCartState();
      this.dispatchEvent(
        new CustomEvent('quantity-change', {
          detail: { value: 0 },
          bubbles: true
        })
      );
      return;
    }

    this.setValue(this.value + amount);
  }

  setCartState(lineItem = null, { animate = false } = {}) {
    const inCart = Boolean(lineItem);
    this.dataset.inCart = String(inCart);
    this.dataset.cartReady = 'true';
    this.value = inCart ? Number(lineItem.quantity) : 0;
    this.input.value = this.value;
    this.stepperTransitionId = (this.stepperTransitionId || 0) + 1;
    const transitionId = this.stepperTransitionId;
    this.classList.remove('is-stepper-entering');

    if (inCart && animate && this.addBtn && this.inner) {
      const restoreFocus = typeof document !== 'undefined' && document.activeElement === this.addBtn;
      this.addBtn.hidden = false;
      this.addBtn.disabled = true;
      this.addBtn.setAttribute('aria-hidden', 'true');
      if (restoreFocus) this.addBtn.blur();
      this.inner.hidden = false;
      this.inner.inert = true;
      this.inner.setAttribute('aria-hidden', 'true');
      void this.offsetWidth;
      this.classList.add('is-stepper-entering');

      const finishTransition = () => {
        if (this.stepperTransitionId !== transitionId) return;
        this.addBtn.hidden = true;
        this.addBtn.removeAttribute('aria-hidden');
        this.inner.inert = false;
        this.inner.removeAttribute('aria-hidden');
        this.classList.remove('is-stepper-entering');
        if (restoreFocus) this.input.focus();
      };

      requestAnimationFrame(() => {
        const animations = this.getAnimations?.({ subtree: true }) || [];
        if (!animations.length) {
          finishTransition();
          return;
        }
        Promise.allSettled(animations.map((animation) => animation.finished)).then(finishTransition);
      });
    } else {
      if (this.addBtn) {
        this.addBtn.hidden = inCart;
        this.addBtn.disabled = false;
        this.addBtn.removeAttribute('aria-hidden');
      }
      if (this.inner) {
        this.inner.hidden = !inCart;
        this.inner.inert = !inCart;
        this.inner.removeAttribute('aria-hidden');
      }
    }

    this.minusBtn.setAttribute(
      'aria-label',
      inCart && this.value - this.step < this.purchaseMin ? 'Remove from cart' : 'Decrease quantity'
    );
    this.updateButtons();
  }

  setValue(val) {
    this.value = Math.min(
      this.max ?? Infinity,
      Math.max(this.min, val)
    );

    this.input.value = this.value;
    this.updateButtons();

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: { value: this.value },
        bubbles: true
      })
    );
  }

  updateButtons() {
    this.minusBtn.disabled = this.dataset.inCart !== 'true' && this.value <= this.min;
    this.plusBtn.disabled = this.max !== null && this.value + this.step > this.max;
  }

  /* -------- Utils -------- */

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('quantity-picker', QuantityPicker);


// =================  PRODUCT MEDIA  ================= //
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.yFrames = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vFrames = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model');
  }

  connectedCallback() {
    if(this.videos.length) {
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })
      })
    }

    if(this.yFrames.length) {
      this.yFrames.forEach((yFrame) => {
        yFrame.nextElementSibling.addEventListener('click', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })
      })
    }

    if(this.vFrames.length) {
      this.vFrames.forEach((vFrame) => {
        vFrame.nextElementSibling.addEventListener('click', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })
      })
    }

    if(this.models.length) {
      this.models.forEach((model) => {
        model.addEventListener('mouseenter', () => {
          lenis.stop();
          document.documentElement.style.overflow = 'auto';
        })

        model.addEventListener('mouseleave', () => {
          lenis.start();
          document.documentElement.style.overflow = 'unset';
        })

        model.addEventListener('click', () => this.handleModelClick(model));
      })
    }
  }

  handleVdoClick(vdo) {
    this.pauseAllMedia(vdo);
    vdo.nextElementSibling.classList.add('hide');
    if(vdo.paused) {
      vdo.play();
      vdo.nextElementSibling.classList.add('hide'); 
    } else {
      vdo.pause();
      vdo.nextElementSibling.classList.remove('hide');
    }
  }

  handleYframeClick(yFrame) {
    this.pauseAllMedia(yFrame);
    yFrame.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  handleVframeClick(vFrame) {
    this.pauseAllMedia(vFrame);
    vFrame.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(model) {
    console.log('click')
    this.pauseAllMedia(model)
  }

  pauseAllMedia(except = null) {
    this.videos.forEach((vdo) => {
      if(vdo != except) {
        vdo.nextElementSibling.classList.remove('hide');
        vdo.pause();
      }
    })

    this.yFrames.forEach((yFrame) => {
      if (yFrame !== except) {
        yFrame.nextElementSibling.style.pointerEvents = 'all';
        yFrame.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    this.vFrames.forEach((vFrame) => {
      if (vFrame !== except) {
        vFrame.nextElementSibling.style.pointerEvents = 'all';
        vFrame.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        const modelViewer = model.querySelector('model-viewer');

        if(!modelViewer) return;
        if (model.modelViewerUI) model.modelViewerUI.pause();
      }
    })
  }
}

customElements.define('product-media', ProductMedia);

// ================= Mobile VIEW  ================= //
class ProductMobileMedia extends HTMLElement {
  constructor({
    thumbnailLayout = new window.HOMGalleryThumbnailLayout.GalleryThumbnailLayout(),
    createSwiper = (element, options) => new Swiper(element, options),
    whenReady = callback => whenSwiperReady(callback),
    imageLoader = window.HOMProductImages,
  } = {}) {
    super();
    Object.assign(this, { thumbnailLayout, createSwiper, whenReady, imageLoader });

    this.mobmainSlider  = this.querySelector('.product_slider_main_media');
    this.mobthumbSlider = this.querySelector('.product_slider_view_thumbnail_media');
    this.spacing        = this.dataset.spacing || 0;

    this.videos         = [...this.querySelectorAll('video')];
    this.youtubeFrames  = [...this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]')];
    this.vimeoFrames    = [...this.querySelectorAll('iframe[src*="vimeo.com"]')];
    this.models         = [...this.querySelectorAll('product-model')];
  }

  connectedCallback() {
    if (!this.mobmainSlider) return;

    this.mediaEventController?.abort();
    this.mediaEventController = new AbortController();
    this.initSwiper();
    this.initVideos();
    this.initYouTube();
    this.initVimeo();
    this.initModels();
  }

  disconnectedCallback() {
    this.swiperInitVersion = (this.swiperInitVersion || 0) + 1;
    this.swiperPending = false;
    this.mediaEventController?.abort();
    this.stopThumbnailLayout?.();
    this.stopThumbnailLayout = null;
    this.mainSwiper?.destroy(true, true);
    this.thumbSwiper?.destroy(true, true);
    this.mainSwiper = null;
    this.thumbSwiper = null;
    this.pauseAll();
    if (this.scrollLocked) this.unlockScroll();
  }

  /* ---------------- Swiper ---------------- */

  initSwiper() {
    
    if (this.mainSwiper || this.swiperPending) return;
    this.swiperPending = true;
    const version = this.swiperInitVersion = (this.swiperInitVersion || 0) + 1;

    this.whenReady(() => {
      if (!this.isConnected || version !== this.swiperInitVersion) return;
      this.swiperPending = false;

      if (this.mobthumbSlider) {
        this.thumbSwiper = this.createSwiper(this.mobthumbSlider, {
          direction: "horizontal",
          ...this.thumbnailLayout.read(this.mobthumbSlider),
          speed: 600,
          watchSlidesProgress: true,
        });
        this.stopThumbnailLayout = this.thumbnailLayout.watch(this.mobthumbSlider, layout => {
          Object.assign(this.thumbSwiper.params, layout);
          this.thumbSwiper.update();
        });
      }

      const imageLoader = this.imageLoader;
      this.mainSwiper = this.createSwiper(this.mobmainSlider, {
        slidesPerView: 1,
        spaceBetween: this.spacing,
        speed: 600,
        autoHeight: true,
        grabCursor: true,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        thumbs: { swiper: this.thumbSwiper },
        on: {
          slideChange() {
            imageLoader.loadSlide(this.slides[this.activeIndex]);
          }
        },
      });
    });
  }


  /* ---------------- Videos ---------------- */

  initVideos() {
    this.videos.forEach(video => {
      ['click', 'touchend'].forEach(evt => {
        video.addEventListener(evt, e => {
          e.preventDefault();
          this.toggleVideo(video);
        }, { signal: this.mediaEventController.signal });
      });
    });
  }

  toggleVideo(video) {
    this.pauseAll(video);

    const overlay = video.nextElementSibling;
    if (!overlay) return;

    if (video.paused) {
      video.play();
      overlay.classList.add('hide');
    } else {
      video.pause();
      overlay.classList.remove('hide');
    }
  }

  /* ---------------- YouTube ---------------- */

  initYouTube() {
    this.youtubeFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          this.postYouTube(frame, 'playVideo');
        }, { signal: this.mediaEventController.signal });
      });
    });
  }

  postYouTube(frame, action) {
    frame.contentWindow?.postMessage(
      JSON.stringify({ event: 'command', func: action, args: [] }),
      '*'
    );
  }

  /* ---------------- Vimeo ---------------- */

  initVimeo() {
    this.vimeoFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          frame.contentWindow?.postMessage({ method: 'play' }, '*');
        }, { signal: this.mediaEventController.signal });
      });
    });
  }

  /* ---------------- Models ---------------- */

  initModels() {
    this.models.forEach(model => {
      const options = { signal: this.mediaEventController.signal };
      model.addEventListener('mouseenter', () => this.lockScroll(), options);
      model.addEventListener('mouseleave', () => this.unlockScroll(), options);
      model.addEventListener('touchstart', () => this.lockScroll(), options);
      model.addEventListener('touchend', () => {
        this.unlockScroll();
        this.pauseAll(model);
      }, options);
    });
  }

  lockScroll() {
    this.scrollLocked = true;
    lenis.stop();
    document.documentElement.style.overflow = 'auto';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
  }

  unlockScroll() {
    this.scrollLocked = false;
    lenis.start();
    document.documentElement.style.overflow = 'unset';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = true;
  }

  /* ---------------- Pause All ---------------- */

  pauseAll(except) {
    this.videos.forEach(v => {
      if (v !== except) {
        v.pause();
        v.nextElementSibling?.classList.remove('hide');
      }
    });

    this.youtubeFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        this.postYouTube(f, 'pauseVideo');
      }
    });

    this.vimeoFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        f.contentWindow?.postMessage({ method: 'pause' }, '*');
      }
    });

    this.models.forEach(model => {
      if (model !== except && model.modelViewerUI) {
        model.modelViewerUI.pause();
        model.querySelector('.shopify-model-viewer-ui__button')?.removeAttribute('hidden');
      }
    });
  }
}

customElements.define('product-slider-view-media', ProductMobileMedia);




//================= MAIN PRODUCT FUNCTION =================== //
class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.originalSectionId = this.dataset.originalSectionId;
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this.btn = this.querySelector('.product_form_buy_button');
    this.baseUrl = this.dataset.baseUrl;
    this.rootSection = this.closest('.product-section');
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('variant-change', this.onVariantChange);
    this.addEventListener('quantity-change', this.onQuantityChange);
  }

  disconnectedCallback() {
    this.removeEventListener('variant-change', this.onVariantChange);
    this.removeEventListener('quantity-change', this.onQuantityChange);
  }

  onQuantityChange(e) {
    const value = e.detail.value;
    const baseInput = this.querySelector('input[name="quantity"]');
    if(baseInput) {
      baseInput.value = value;
    }    
  }

  onVariantChange(e) {
    const selectedOptions = e.detail.selectedOptions;
    
    this.requestURL = this.buildURL(selectedOptions);
    
    this.loadInfo(this.requestURL);
  }

  buildURL(options) {
    const params = [];
    if(options.length) {
      params.push(`option_values=${options.join(',')}`);
    }

    if(this.isMainProduct != 'true') {
      return `${this.productUrl}?section_id=${this.sectionId}&${params.join('&')}`;
    } else {
      return `${this.productUrl}?${params.join('&')}`;
    }    
  }

  loadInfo(url) {
    fetch(url)
    .then((res) => res.text())
    .then((htmlString) => {
      const html = new DOMParser().parseFromString(htmlString, 'text/html');
      this.updateContent(html);
    })
  }

  updateContent(html) {    
    const originalSectionId = this.dataset.originalSectionId;
    const container = html.querySelector('main-product-section');

    if(!container) return;

    if(this.sectionId.includes('quick-add')) {
      const newSectionId = `quick-add-${originalSectionId}`;  
      console.log(newSectionId, originalSectionId);
      console.log(html);
      
      container.innerHTML = container.innerHTML.replaceAll(originalSectionId, newSectionId);
    }

    container.dataset.sectionId = this.sectionId;

    this.updateVariantFragments(container);

    const visibleQuantityInput = this.querySelector(`#Quantity-${this.sectionId} input[type="text"]`);
    const baseQuantityInput = this.querySelector('input[name="quantity"]');

    if(baseQuantityInput) {
      baseQuantityInput.value = visibleQuantityInput?.value || 1;
    }

    // UPDATE ADD TO CART BUTTON
    const oldBtn = this.querySelector('product-form');
    const newBtn = html.querySelector('product-form');

    if(oldBtn && newBtn) {
      oldBtn.innerHTML = newBtn.innerHTML;
      oldBtn.syncCartState?.();
    }

    // UPDATE FEATURED MEDIA
    // const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
    // const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

    
    // if(oldFeaturedMedia && newFeaturedMedia) {
    //   oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
    // }

    // // UPDATE MOBILE MEDIA
    // const oldMedia = this.querySelector('.product_slider_wrapper');
    // const newMedia = html.querySelector('.product_slider_wrapper');

    // if(oldMedia && newMedia) {
    //   oldMedia.innerHTML = newMedia.innerHTML;
    // }

    const variantData = this.extractVariantData(html);


    const backInStock = this.querySelector('[data-back-in-stock]');

    if (backInStock && variantData) {
      backInStock.hidden = variantData.available;
      backInStock.setAttribute('aria-hidden', String(variantData.available));

      const variantInput = backInStock.querySelector('[data-notification-variant]');
      const variantTitleInput = backInStock.querySelector('[data-notification-product]');
      const notificationForm = backInStock.querySelector('.back-in-stock-form');

      if (variantInput) variantInput.value = variantData.id;
      if (variantTitleInput) variantTitleInput.value = variantData.title || variantData.name || '';

      if (notificationForm && notificationForm.dataset.subscribedVariant !== String(variantData.id)) {
        notificationForm.dataset.submitting = 'false';
        notificationForm.removeAttribute('aria-busy');
        setBackInStockButtonLoading(notificationForm.querySelector('button[type="submit"]'), false);
      }

      checkBackInStockStatus(backInStock);
    }

    if (variantData) {
      const oldMedia = this.querySelector('.main_product_media');
      const newMedia = html.querySelector('.main_product_media');

      if(oldMedia && newMedia) {
        oldMedia.innerHTML = newMedia.innerHTML;
      }
    } else {
      console.log('Media not updated - invalid variant');
    }

    if(this.dataset.updateUrl === 'true') {
      this.updateURL(html);
    }    

    this.setMainInput(html);


    const addToCartBtn =
        this.querySelector('.product_form_buy_button');

  }

  updateVariantFragments(source) {
    source.querySelectorAll('[data-variant-fragment]').forEach((newFragment) => {
      const fragmentName = newFragment.dataset.variantFragment;
      const currentFragment = this.querySelector(`[data-variant-fragment="${fragmentName}"]`);

      if(!currentFragment) return;

      if(newFragment.dataset.variantUpdate === 'outer') {
        currentFragment.replaceWith(newFragment.cloneNode(true));
      } else {
        currentFragment.innerHTML = newFragment.innerHTML;
      }
    });
  }
  
  extractVariantData(html) {
    const data = html.querySelector('[data-selected-variant]')?.innerHTML;
    if(!data) return;

    return JSON.parse(data);
  }

  updateURL(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    window.history.replaceState(null, {}, `${this.productUrl}?variant=${variantData.id}`);

    this.handlePickup(variantData.id);
  }

  handlePickup(id) {
    let baseUrl = this.dataset.baseUrl;
    if(!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    fetch(`${baseUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pickup_availability_wrapper');

      if(container && newHTML) {
        container.innerHTML = newHTML.innerHTML;
        initPickupAccordion(container);
        const pickUpDrawer = container.querySelector('pickup-availability-drawer');
        const pickUpBtn = container.querySelector('.accordion_open_btn_pickup');
        // Pickup CODE =============
        if(pickUpDrawer && pickUpBtn) {
          // pickUpBtn.addEventListener('click', () => {
          //   openDrawer(pickUpDrawer, pickUpBtn, this.rootSection);
          // })          
            if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          
        }

        if(pickUpDrawer) {
          if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
      }
    })

  }
  

  setMainInput(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    this.querySelector('input[name="id"]').value = variantData.id;
  }
}

customElements.define('main-product-section', MainProduct);


// ================= PRODUCT FORM  ================= //

async function requestCartJson(url, options = {}) {
  const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...options.headers
  };
  const response = await fetch(url, { ...options, headers });
  const data = await response.json();

  if (!response.ok) throw data;
  return data;
}

const sharedCartState = {
  data: null,
  request: null,
  refreshRequest: null,

  async get() {
    if (this.data) return this.data;
    if (this.request) return this.request;

    this.request = requestCartJson(window.HOM_API_PATHS.cart)
      .then((cart) => {
        this.data = cart;
        return cart;
      })
      .finally(() => {
        this.request = null;
      });

    return this.request;
  },

  async refresh() {
    if (this.refreshRequest) return this.refreshRequest;

    this.refreshRequest = (async () => {
      if (this.request) {
        try {
          await this.request;
        } catch (_) {
          // A failed cached request must not prevent the authoritative refresh.
        }
      }

      this.data = null;
      return this.get();
    })().finally(() => {
      this.refreshRequest = null;
    });

    return this.refreshRequest;
  },

  set(cart) {
    this.data = cart;
  }
};

function normalizeLineProperties(properties = {}) {
  return Object.entries(properties || {})
    .filter(([, value]) => value !== null && String(value).length > 0)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
}

function linePropertiesMatch(cartProperties, formProperties) {
  return JSON.stringify(normalizeLineProperties(cartProperties)) ===
    JSON.stringify(normalizeLineProperties(formProperties));
}

function showSiteToast({
  title,
  subtitle = '',
  image = '',
  imageAlt = '',
  actionLabel = '',
  actionUrl = '',
  duration = 4000
} = {}) {
  const toast = document.querySelector('[data-site-toast]');
  if (!toast || !title) return;

  clearTimeout(toast.hideTimer);
  if (toast.scrollDismissHandler) {
    window.removeEventListener('scroll', toast.scrollDismissHandler);
  }

  const hideToast = ({ immediate = false } = {}) => {
    clearTimeout(toast.hideTimer);
    toast.classList.toggle('dismiss-immediately', immediate);
    toast.classList.remove('show');
    toast.setAttribute('aria-hidden', 'true');

    if (toast.scrollDismissHandler) {
      window.removeEventListener('scroll', toast.scrollDismissHandler);
      toast.scrollDismissHandler = null;
    }
  };

  const titleElement = toast.querySelector('.site-toast__title');
  const subtitleElement = toast.querySelector('.site-toast__subtitle');
  const imageElement = toast.querySelector('.site-toast__image');
  const actionElement = toast.querySelector('.site-toast__action');

  if (titleElement) titleElement.textContent = title;

  if (subtitleElement) {
    subtitleElement.textContent = subtitle;
    subtitleElement.classList.toggle('hidden', !subtitle);
  }

  if (imageElement) {
    imageElement.classList.toggle('hidden', !image);
    imageElement.style.backgroundImage = image ? `url("${image.replace(/"/g, '\\"')}")` : '';
    imageElement.setAttribute('aria-label', image ? imageAlt || title : '');
  }

  if (actionElement) {
    actionElement.textContent = actionLabel;
    actionElement.href = actionUrl || '#';
    actionElement.classList.toggle('hidden', !actionLabel || !actionUrl);
  }

  toast.classList.remove('show', 'dismiss-immediately');
  toast.setAttribute('aria-hidden', 'false');
  // Restart the transition immediately. Animation frames can be heavily
  // throttled in background/new tabs and otherwise race the hide timer.
  void toast.offsetWidth;
  toast.classList.add('show');

  toast.scrollDismissHandler = () => hideToast({ immediate: true });
  window.addEventListener('scroll', toast.scrollDismissHandler, { passive: true, once: true });
  toast.hideTimer = setTimeout(() => hideToast(), duration);
}

window.showSiteToast = showSiteToast;

function showCartItemToast(item, { fallbackTitle = '', quantity = 1 } = {}) {
  const toast = document.querySelector('[data-site-toast]');
  if (!toast) return false;

  const productTitle = item?.product_title || fallbackTitle;
  const variantTitle = item?.variant_title && item.variant_title !== 'Default Title'
    ? item.variant_title
    : '';

  showSiteToast({
    title: toast.dataset.cartTitle || 'Added to cart',
    subtitle: [productTitle, variantTitle, `Qty ${Number(item?.quantity || quantity)}`]
      .filter(Boolean)
      .join(' · '),
    image: item?.featured_image?.url || item?.image || '',
    imageAlt: productTitle,
    actionLabel: 'View cart',
    actionUrl: window.HOM_API_PATHS.cartPage
  });

  return true;
}

const productCardLayouts = [
  { root: 'product-card', price: '.product-card-price', title: '.product-card-title a' },
  { root: '.custom-product-card', price: '.custom-product-price', title: '.custom-product-title a' },
  { root: '.product_tab__cards_wrpr', price: 'div.pdp_price', title: '.pdp_title a' },
  { root: '.product_media.swiper-slide', price: 'div.pdp_price', title: '.pdp_title a', preserveLayout: true },
  { root: '.pdp_cards_content', price: 'div.pdp_price', title: '.pdp_title a' },
  { root: '.spotlight-custom-card', price: '.scc-price', title: '.scc-title a' },
  { root: '.promo-card-inner', price: '.promo-card-price', title: '.promo-card-name a' }
];

function findProductCardContext(element, layouts = productCardLayouts) {
  if (!element?.closest) return null;
  for (const layout of layouts) {
    const card = element.closest(layout.root);
    if (card) return { card, layout };
  }
  return null;
}

function getCardNavigationContext(element, layouts = productCardLayouts) {
  const context = findProductCardContext(element, layouts);
  if (!context) return { card: null, productLink: null };
  const { card, layout } = context;
  return {
    card,
    productLink: card.querySelector(layout.title) || card.querySelector('a[href*="/products/"]')
  };
}

function getCardControlContext(element) {
  const context = findProductCardContext(element);
  if (!context) return { card: null, price: null, productLink: null };
  const { card, layout } = context;
  return {
    card,
    price: card.querySelector(layout.price),
    productLink: card.querySelector(layout.title) || card.querySelector('a[href*="/products/"]'),
    preserveLayout: Boolean(layout.preserveLayout)
  };
}

class ProductCardGestureTracker {
  constructor({ movementThreshold = 8, suppressionDuration = 800, now = Date.now } = {}) {
    this.movementThreshold = movementThreshold;
    this.suppressionDuration = suppressionDuration;
    this.now = now;
    this.reset();
  }

  reset() {
    this.gesture = null;
    this.suppressedCard = null;
    this.suppressUntil = 0;
  }

  start(event, card) {
    if (event.isPrimary === false) {
      if (this.gesture) this.gesture.moved = true;
      return;
    }
    this.reset();
    if (event.button !== 0 || !card) return;
    this.gesture = { card, pointerId: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
  }

  move(event) {
    if (!this.gesture || event.pointerId !== this.gesture.pointerId) return;
    if (Math.hypot(event.clientX - this.gesture.x, event.clientY - this.gesture.y) > this.movementThreshold) {
      this.gesture.moved = true;
    }
  }

  end(event) {
    if (!this.gesture || event.pointerId !== this.gesture.pointerId) return;
    this.move(event);
    if (this.gesture.moved || event.type === 'pointercancel') {
      this.suppressedCard = this.gesture.card;
      this.suppressUntil = this.now() + this.suppressionDuration;
    }
    this.gesture = null;
  }

  shouldSuppressClick(event, card) {
    return event.detail !== 0 && card === this.suppressedCard && this.now() < this.suppressUntil;
  }
}

function canNavigateProductCard(event) {
  const interactiveSelector = 'a, button, input, select, textarea, label, form, summary, video, audio, [role="button"], [role="link"], [contenteditable]:not([contenteditable="false"]), product-form, quantity-picker, [data-back-in-stock]';
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  if (!event.target?.closest || event.target.closest(interactiveSelector)) return false;
  if (window.getSelection()?.isCollapsed === false) return false;
  let slider = event.target.closest('.swiper');
  while (slider) {
    if (slider.swiper?.allowClick === false) return false;
    slider = slider.parentElement?.closest('.swiper');
  }
  return true;
}

class ProductCardNavigationController {
  constructor({ eventRoot, resolveContext, gestures, canNavigate, activateLink }) {
    this.eventRoot = eventRoot;
    this.resolveContext = resolveContext;
    this.gestures = gestures;
    this.canNavigate = canNavigate;
    this.activateLink = activateLink;
    this.connected = false;
    const pointerOptions = { capture: true, passive: true };
    this.listeners = [
      ['pointerdown', (event) => this.gestures.start(event, this.resolveContext(event.target).card), pointerOptions],
      ['pointermove', (event) => this.gestures.move(event), pointerOptions],
      ['pointerup', (event) => this.gestures.end(event), pointerOptions],
      ['pointercancel', (event) => this.gestures.end(event), pointerOptions],
      ['click', (event) => this.suppressDraggedClick(event), true],
      ['click', (event) => this.navigate(event), false]
    ];
  }

  connect() {
    if (this.connected) return;
    this.listeners.forEach(([type, listener, options]) => this.eventRoot.addEventListener(type, listener, options));
    this.connected = true;
  }

  disconnect() {
    this.listeners.forEach(([type, listener, options]) => this.eventRoot.removeEventListener(type, listener, options));
    this.gestures.reset();
    this.connected = false;
  }

  suppressDraggedClick(event) {
    const { card } = this.resolveContext(event.target);
    if (!card || !this.gestures.shouldSuppressClick(event, card)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  navigate(event) {
    if (!this.canNavigate(event)) return;
    const { card, productLink } = this.resolveContext(event.target);
    if (card && productLink) this.activateLink(productLink);
  }
}

const productCardNavigation = new ProductCardNavigationController({
  eventRoot: document,
  resolveContext: getCardNavigationContext,
  gestures: new ProductCardGestureTracker(),
  canNavigate: canNavigateProductCard,
  activateLink: (link) => link.click()
});
productCardNavigation.connect();

function submitCardBackInStock(button) {
  const config = window.HOM_BACK_IN_STOCK || {};
  if (!config.customerLoggedIn) {
    const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
    if (isLocalPreview) {
      showSiteToast({
        title: 'Customer session unavailable in preview',
        subtitle: 'Test restock alerts on the Shopify storefront where your customer session is available.',
        actionLabel: 'Open product',
        actionUrl: button.dataset.productUrl || window.location.href
      });
      return;
    }

    const loginUrl = new URL(config.loginUrl || window.HOM_API_PATHS.accountLogin, window.location.origin);
    const productReturnUrl = button.dataset.productUrl
      ? `${new URL(button.dataset.productUrl, window.location.origin).pathname}#back-in-stock`
      : window.location.pathname;
    const returnParameter = loginUrl.pathname.includes('customer_authentication') ? 'return_to' : 'return_url';
    loginUrl.searchParams.set(returnParameter, productReturnUrl);
    window.location.assign(loginUrl.toString());
    return;
  }

  if (!config.endpoint || button.dataset.submitting === 'true') return;

  const requestId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const frameName = `CardBackInStock-${requestId}`;
  const frame = document.createElement('iframe');
  const form = document.createElement('form');
  const fields = {
    email: config.customerEmail || '',
    customer_id: config.customerId || '',
    variant_id: button.dataset.variantId || '',
    variant_title: button.dataset.variantTitle || '',
    product_title: button.dataset.productTitle || '',
    product_handle: button.dataset.productHandle || '',
    product_url: button.dataset.productUrl || '',
    image_url: button.dataset.imageUrl || '',
    request_id: requestId,
    website: ''
  };

  frame.name = frameName;
  frame.hidden = true;
  frame.setAttribute('aria-hidden', 'true');
  form.action = config.endpoint;
  form.method = 'post';
  form.target = frameName;
  form.hidden = true;

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.append(input);
  });

  button.dataset.submitting = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  document.body.append(frame, form);

  const cleanup = () => {
    button.dataset.submitting = 'false';
    button.disabled = false;
    button.removeAttribute('aria-busy');
    form.remove();
    frame.remove();
  };
  const timeout = window.setTimeout(() => {
    window.removeEventListener('message', handleResponse);
    cleanup();
    showSiteToast({ title: 'Could not set alert', subtitle: 'Please try again.' });
  }, 15000);

  function handleResponse(event) {
    if (!isAppsScriptMessage(event) || event.data?.type !== 'back-in-stock-response' || event.data.requestId !== requestId) return;
    window.clearTimeout(timeout);
    window.removeEventListener('message', handleResponse);
    cleanup();
    showSiteToast({
      title: event.data.ok ? "You're on the list" : 'Could not set alert',
      subtitle: event.data.ok
        ? `We'll notify you when ${button.dataset.productTitle || 'this item'} is back in stock.`
        : 'Please try again.',
      image: button.dataset.imageUrl || '',
      imageAlt: button.dataset.productTitle || ''
    });
  }

  form.submit();
}

class ProductatcForm extends HTMLElement {
  constructor() {
    super();
    this.submit = this.submit.bind(this);
    this.refresh = this.cache.bind(this);
    this.syncCartState = this.syncCartState.bind(this);
    this.onCartQuantityChange = this.onCartQuantityChange.bind(this);
  }

  connectedCallback() {
    if (this.setupCardCartControl() === false) return;
    this.cache();
    this.addEventListener('submit', this.submit);
    this.addEventListener('variant-change', this.refresh);
    document.addEventListener('cart-update', this.syncCartState);
    document.addEventListener('quantity-change', this.onCartQuantityChange);

    if (this.cartStepperEnabled) {
      this.syncCartState();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.submit);
    this.removeEventListener('variant-change', this.refresh);
    document.removeEventListener('cart-update', this.syncCartState);
    document.removeEventListener('quantity-change', this.onCartQuantityChange);
  }

  setupCardCartControl() {
    if (this.closest('main-product-section') || this.querySelector('.product-card-cart-control')) return true;

    const form = this.querySelector('form');
    const button = form?.querySelector('.product_form_buy_button');
    if (!form || !button) return true;

    const variantInput = form.querySelector('input[name="id"]');
    const controlShell = this.closest('.pdp_quickyview, .promo-card-atc-wrap, .scc-quick-view');

    if (variantInput?.disabled) {
      const { card, productLink } = getCardControlContext(this);
      const productUrl = productLink?.href || '';
      const restockButton = document.createElement('button');

      restockButton.type = 'button';
      restockButton.className = 'card-restock-button';
      restockButton.setAttribute('aria-label', 'Notify me when available');
      restockButton.dataset.variantId = variantInput.value;
      restockButton.dataset.variantTitle = 'Default Title';
      restockButton.dataset.productTitle = productLink?.textContent?.trim() || '';
      restockButton.dataset.productUrl = productUrl;
      restockButton.dataset.productHandle = productUrl.split('/products/')[1]?.split(/[?#]/)[0] || '';
      restockButton.dataset.imageUrl = card?.querySelector('img')?.currentSrc || card?.querySelector('img')?.src || '';
      restockButton.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M18 10a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/><path d="M14 22h-4" stroke="currentColor" stroke-linecap="round" stroke-width="1.7"/></svg>`;
      restockButton.addEventListener('click', () => submitCardBackInStock(restockButton));

      controlShell?.classList.add('has-card-cart-control', 'has-card-restock-control');
      this.setupCardPurchaseRow(controlShell);
      controlShell?.querySelector('.quick_view_innerblock')?.replaceChildren(restockButton);
      return false;
    }

    const buttonParent = button.parentElement;
    const loader = button.querySelector('.loader');
    const addLabel = document.createElement('span');
    const picker = document.createElement('quantity-picker');
    const quantityInner = document.createElement('div');

    addLabel.className = 'atc_status';
    addLabel.textContent = 'ADD';

    button.type = 'button';
    button.classList.add('stepper_add_button', 'product-card-cart-add');
    button.setAttribute('data-stepper-add', '');
    button.setAttribute('aria-label', 'Add to cart');
    button.replaceChildren(addLabel);
    if (loader) button.append(loader);

    picker.className = 'product-card-cart-control cart-stepper-control';
    picker.setAttribute('data-cart-control', 'true');
    picker.setAttribute('data-purchase-min', variantInput?.dataset.quantityMin || '1');
    picker.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    quantityInner.className = 'quantity_inner';
    quantityInner.hidden = true;
    quantityInner.innerHTML = `
      <button type="button" class="btn_minus" data-minus aria-label="Decrease quantity">−</button>
      <input type="text" value="0" data-min="0" ${variantInput?.dataset.quantityMax ? `data-max="${variantInput.dataset.quantityMax}"` : ''} step="${variantInput?.dataset.quantityIncrement || '1'}" inputmode="numeric" aria-label="Quantity" readonly>
      <button type="button" class="btn_plus" data-plus aria-label="Increase quantity">+</button>
    `;

    picker.append(button, quantityInner);
    buttonParent.append(picker);
    this.dataset.enableCartStepper = 'true';
    this.classList.add('product-card-cart-form');
    controlShell?.classList.add('has-card-cart-control');
    this.setupCardPurchaseRow(controlShell);
    return true;
  }

  setupCardPurchaseRow(controlShell) {
    const { card, price, preserveLayout } = getCardControlContext(this);
    if (!card || !price || !controlShell || price.closest('.product-card-purchase-row')) return;

    // The hero product slider already has a purpose-built horizontal overlay.
    // Moving its controls into the nested price column breaks that composition.
    if (preserveLayout) {
      card.querySelector('.ftd_pdp_info')?.classList.add('has-card-purchase-control');
      return;
    }

    const row = document.createElement('div');
    row.className = 'product-card-purchase-row';
    price.parentElement.insertBefore(row, price);
    row.append(price, controlShell);

    // Standard cards may render thumbnails after the price. Keep the complete
    // MRP/ATC row as the final card element so controls share one baseline.
    if (card.matches('product-card')) {
      const thumbnailRow = card.querySelector('.thmb-img-btn-wrap');
      if (thumbnailRow) thumbnailRow.after(row);
    }
  }

  cache() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.product_form_buy_button');
    this.text = this.btn?.querySelector('.atc_status');
    this.load = this.btn?.querySelector('.loader');
    this.cart = document.querySelector('cart-contents');
    this.open = false;
    this.cartStepperEnabled = this.dataset.enableCartStepper === 'true';

    this.giftWrap = document.querySelector('#product_gift_wrapp');
    this.mainInput = this.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
  }

  get quantityPicker() {
    return this.querySelector('quantity-picker[data-cart-control="true"]') ||
      this.closest('main-product-section')
        ?.querySelector('.main_product_quantity_wrapper quantity-picker[data-cart-control="true"]');
  }

  getCartIdentity() {
    if (!this.form) return null;

    const formData = new FormData(this.form);
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && String(value).length > 0) {
        properties[match[1]] = String(value);
      }
    }

    return {
      productId: Number(this.dataset.productId || this.mainInput?.dataset.productId),
      variantId: Number(formData.get('id')),
      properties
    };
  }

  setPurchaseState(lineItem = null, { animate = false } = {}) {
    if (!this.cartStepperEnabled) return;

    const inCart = Boolean(lineItem);
    this.cartLineKey = inCart ? lineItem.key : null;
    this.cartLineQuantity = inCart ? Number(lineItem.quantity) : 0;

    if (this.quantityPicker) this.quantityPicker.hidden = false;
    this.quantityPicker?.setCartState(lineItem, { animate });

    const quantityInput = this.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = inCart ? lineItem.quantity : 0;
    }
  }

  async syncCartState(event) {
    if (event?.detail?.source === this) return;

    this.cache();
    if (!this.cartStepperEnabled || !this.form) return;

    if (this.mainInput?.disabled) {
      if (this.quantityPicker) {
        this.quantityPicker.dataset.cartReady = 'true';
        this.quantityPicker.hidden = false;
        this.quantityPicker.setCartState();
        if (this.quantityPicker.addBtn) this.quantityPicker.addBtn.disabled = true;
      }
      return;
    }

    const details = this.getCartIdentity();
    if (!details?.variantId) {
      this.setPurchaseState();
      return;
    }

    try {
      const cartData = event?.detail?.cartData || (
        event ? await sharedCartState.refresh() : await sharedCartState.get()
      );
      const lineItem = cartData.items.find((item) =>
        (!details.productId || Number(item.product_id) === details.productId) &&
        Number(item.variant_id) === details.variantId &&
        linePropertiesMatch(item.properties, details.properties)
      );

      this.setPurchaseState(lineItem);
    } catch (error) {
      console.error('Cart state error:', error);
      this.setPurchaseState();
    }
  }

  async onCartQuantityChange(event) {
    if (!this.cartStepperEnabled) return;

    const mainProduct = this.closest('main-product-section');
    const isOwnedCardPicker = this.contains(event.target);
    const isOwnedPdpPicker = Boolean(
      mainProduct &&
      mainProduct.querySelector('product-form[data-enable-cart-stepper="true"]') === this &&
      this.quantityPicker === event.target
    );
    if (!isOwnedCardPicker && !isOwnedPdpPicker) return;

    const quantity = Number(event.detail.value);
    if (!Number.isFinite(quantity) || quantity < 0) return;

    if (!this.cartLineKey) {
      if (quantity === 0) return;

      if (event.target.addBtn) event.target.addBtn.disabled = true;
      const quantityInput = this.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = event.target.dataset.purchaseMin || quantity;
      }
      this.form?.requestSubmit();
      return;
    }

    this.pendingCartQuantity = quantity;
    if (this.quantityUpdatePromise) return this.quantityUpdatePromise;

    this.quantityUpdatePromise = this.flushCartQuantityChanges();
    try {
      await this.quantityUpdatePromise;
    } finally {
      this.quantityUpdatePromise = null;
    }
  }

  async flushCartQuantityChanges() {
    while (this.pendingCartQuantity !== undefined) {
      const quantity = this.pendingCartQuantity;
      this.pendingCartQuantity = undefined;
      const previousLineKey = this.cartLineKey;
      const previousQuantity = Number(this.cartLineQuantity || 0);

      try {
        const data = await requestCartJson(window.HOM_API_PATHS.cartChange, {
          method: 'POST',
          body: JSON.stringify({ id: previousLineKey, quantity })
        });
        sharedCartState.set(data);

        const updatedLineItem = data.items?.find((item) => item.key === previousLineKey) || null;
        this.setPurchaseState(updatedLineItem);
        if (updatedLineItem && quantity > previousQuantity) {
          showCartItemToast(updatedLineItem, {
            fallbackTitle: this.mainInput?.dataset.title || '',
            quantity
          });
        }
        await this.refreshCartSections(data);
      } catch (error) {
        this.pendingCartQuantity = undefined;
        this.showError(error);
        await this.syncCartState({ detail: {} });
      }
    }
  }

  async refreshCartSections(cartData = null) {
    const sections = await requestCartJson(
      window.HOM_API_PATHS.cartSections
    );

    document.dispatchEvent(
      new CustomEvent('cart-update', {
        detail: { sections, cartData, source: this },
        bubbles: true
      })
    );
  }

  async submit(e) {
    // A product-form owns exactly one form. Ignore submit events from any
    // nested/adjacent markup so one card can never submit another product.
    if (!(e.target instanceof HTMLFormElement) || e.target !== this.form) return;

    e.preventDefault();
    e.stopPropagation();

    this.cache();
    if (!this.form || !this.btn) return;

    const loaderStartedAt = performance.now();
    const minimumLoaderDuration = 400;
    this.text.style.visibility = 'hidden';
    this.load.classList.remove('hidden');
    this.btn.disabled = true;

    const formData = new FormData(this.form);

    try {
      const payload = {};

      for (const [key, value] of formData.entries()) {
        const propertyMatch = key.match(/^properties\[(.+)\]$/);

        if (propertyMatch) {
          if (!payload.properties) payload.properties = {};
          payload.properties[propertyMatch[1]] = value;
        } else {
          payload[key] = value;
        }
      }

      const items = [payload];

      if (this.giftWrap && this.giftWrap.checked) {
        items.push({
          id: this.giftWrap.value,
          quantity: 1,
          parent_id: this.mainInput?.value,
          properties: {
            for: `${this.mainInput?.dataset.title || ''}`
          }
        });
      }
      const data = await requestCartJson(window.HOM_API_PATHS.cartAdd, {
        method: 'POST',
        body: JSON.stringify({ items })
      });

      // Fast cart responses can replace ADD with the stepper before the
      // browser paints a loading frame. Keep feedback visible long enough to
      // be perceived consistently in PDP rails and other product cards.
      const loaderElapsed = performance.now() - loaderStartedAt;
      if (loaderElapsed < minimumLoaderDuration) {
        await new Promise((resolve) => window.setTimeout(resolve, minimumLoaderDuration - loaderElapsed));
      }

      if (this.cartStepperEnabled && data.items?.[0]) {
        this.setPurchaseState(data.items[0], { animate: true });
      }

      const addedItem = data.items?.find((item) =>
        Number(item.variant_id || item.id) === Number(payload.id)
      ) || data.items?.[0];
      const toastShown = showCartItemToast(addedItem, {
        fallbackTitle: this.mainInput?.dataset.title || '',
        quantity: Number(payload.quantity || 1)
      });

      // Feedback should not wait for the cart drawer's secondary network calls.
      // Keep those calls best-effort because the add itself has already succeeded.
      try {
        const cartData = await sharedCartState.refresh();
        if (this.cart) await this.refreshCartSections(cartData);
      } catch (refreshError) {
        console.error('Cart refresh error:', refreshError);
      }

      if (toastShown) {
        this.open = false;
        const quickAddDrawer = this.closest('.quick_add_slide');
        if (quickAddDrawer) closeDrawer(quickAddDrawer);
      } else if (this.cart) {
        this.open = true;
      } else {
        window.location.assign(window.HOM_API_PATHS.cartPage);
      }

    } catch (err) {
      this.showError(err);
    } finally {
      const loaderElapsed = performance.now() - loaderStartedAt;
      if (loaderElapsed < minimumLoaderDuration) {
        await new Promise((resolve) => window.setTimeout(resolve, minimumLoaderDuration - loaderElapsed));
      }
      if (this.text) this.text.style.visibility = 'visible';
      this.load?.classList.add('hidden');
      if (this.btn && !this.cartLineKey) this.btn.disabled = false;
      if (this.quantityPicker?.addBtn && !this.cartLineKey) {
        this.quantityPicker.addBtn.disabled = false;
      }

      // --- drawer behavior ---
      if (this.open && this.cart) {
        const openBtn = document.querySelector('.cart_sidebar_open_btn');
        if (openBtn) {
          openBtn.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true })
          );
        }
      }
    }
  }

   showError(data) {
    const error = this.querySelector('.product_add_error');
    if (!error) return;

    let message = 'Unable to add product to cart';

    if (data?.errors && typeof data.errors === 'object') {
      const formattedErrors = [];

      Object.entries(data.errors).forEach(([field, value]) => {
        // Human-friendly field names with fallback
        let fieldLabel = field === 'email' ? 'Email' : field;

        // Normalize message
        if (value === "can't be blank") {
          formattedErrors.push(`${fieldLabel} can't be blank`);
        } 
        else if (value === 'is invalid') {
          formattedErrors.push(`${fieldLabel} is invalid`);
        } 
        else if (fieldLabel === 'send_on'){
          formattedErrors.push(`Send on must be within 90 days from now`);
        }
        else {
          formattedErrors.push(`${fieldLabel} ${value}`);
        }
      
      });

        message = formattedErrors.join('<br>');
      }
      else if (typeof data?.errors === 'string') {
        message = data.errors;
      }
      else if (typeof data?.description === 'string') {
        message = data.description;
      }
      else if (typeof data?.message === 'string') {
        message = data.message;
      }

      error.innerHTML = message;
      error.classList.remove('hidden');
   }
  
}



customElements.define('product-form', ProductatcForm);


// ================== Size chart ========== //

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.size_chart_popup_main');
  const closeBtn = document.querySelector('.size_chart_popup_close');

  // Open popup
  document.addEventListener('click', (e) => {
    if (e.target.closest('.size_chart_main')) {
      popup.classList.add('active');
      document.body.classList.add('size-chart-active');

      if (typeof lenis !== 'undefined') {
        lenis.stop();
      }
    }
  });

  // Close on outside click
  if (popup) {
    popup.addEventListener('click', (e) => {
      if (!e.target.closest('.size_chart_popup_inner')) {
        closePopup();
      }
    });
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  function closePopup() {
    popup.classList.remove('active');
    document.body.classList.remove('size-chart-active');

    if (typeof lenis !== 'undefined') {
      lenis.start();
    }
  }
});
/* ======================================================================
   MAIN PRODUCT PAGE Component end
   ====================================================================== */

/* ======================================================================
   Cart page and cart drawer PAGE Component 
   ====================================================================== */

  //  ================= Side cart drawer open and close ===================

document.addEventListener("DOMContentLoaded", function () {
  const openBtns = document.querySelectorAll(".cart_sidebar_open_btn");
  const closeBtn = document.querySelector(".drawer_close_btn-cart");
  const cartSidebar = document.querySelector(".cart_sidebar_wrapper");
  if (!cartSidebar) return;
  const html = document.documentElement;
  const body = document.body;

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input:not([disabled]),
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  let firstFocusableEl = null;
  let lastFocusableEl = null;

  function setFocusableElements() {
    const focusables = cartSidebar.querySelectorAll(focusableSelectors);
    firstFocusableEl = focusables[0];
    lastFocusableEl = focusables[focusables.length - 1];
  }

  function openCart(e) {
    if (window.matchMedia('(max-width: 768px)').matches) return;
    if (e) e.preventDefault();

    lastFocusedElement = document.activeElement;

    body.classList.add("cart-sidebar-open");
    html.classList.add("lenis-stopped");

    cartSidebar.classList.add("cart-sidebar-active");
    cartSidebar.removeAttribute("inert");
    cartSidebar.setAttribute("aria-hidden", "false");

    setFocusableElements();
    firstFocusableEl?.focus();
  }

  function closeCart(e) {
    if (e) e.preventDefault();

    body.classList.remove("cart-sidebar-open");
    html.classList.remove("lenis-stopped");

    cartSidebar.classList.remove("cart-sidebar-active");
    cartSidebar.setAttribute("inert", "");
    cartSidebar.setAttribute("aria-hidden", "true");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  /* ==========================
     Focus Trap (TAB Handling)
     ========================== */
  document.addEventListener("keydown", function (e) {
    if (!cartSidebar.classList.contains("cart-sidebar-active")) return;

    if (e.key === "Escape") {
      closeCart();
      return;
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  });

  /* ==========================
     Click Outside to Close
     ========================== */
  cartSidebar.addEventListener("click", function (e) {
    if (e.target === cartSidebar) {
      closeCart();
    }
  });

  openBtns.forEach((button) => button.addEventListener("click", openCart));
  closeBtn?.addEventListener("click", closeCart);
});



//  ================= Side cart drawer (CART QUANTITY PICKER) =================== //
class ItemQuantity extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value);
    this.step = Number(this.input.getAttribute('step')) || 1;
    this.min = Number(this.input.dataset.min || 1);
    this.max = this.input.dataset.max ? Number(this.input.dataset.max) : null;
    this.line = this.dataset.line;
    this.handleChange = this.handleChange.bind(this);
    this.handleInput = this._debounce(this.handleInput.bind(this), 300);
    this.dispatchQuantityChange = this._debounce(this.dispatchQuantityChange.bind(this), 150);
  }

  connectedCallback() {
    this.minusBtn?.addEventListener('click', this.handleChange);
    this.plusBtn?.addEventListener('click', this.handleChange);
    this.input?.addEventListener('input', this.handleInput);
    this.syncControls();
  }

  disconnectedCallback() {
    this.minusBtn?.removeEventListener('click', this.handleChange);
    this.plusBtn?.removeEventListener('click', this.handleChange);
    this.input?.removeEventListener('input', this.handleInput);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      const nextValue = this.value + this.step;
      if (this.max !== null && nextValue > this.max) return;
      this.value = nextValue;
    } else {
      this.value = this.value <= this.min ? 0 : Math.max(this.min, this.value - this.step);
    }

    this.input.value = this.value;
    this.syncControls();
    this.dispatchQuantityChange();
  }

  handleInput() {
    const enteredValue = Number.parseInt(this.input.value, 10);
    if (!Number.isFinite(enteredValue)) {
      this.input.value = this.value;
      return;
    }

    const cappedValue = this.max === null ? enteredValue : Math.min(enteredValue, this.max);
    const normalizedValue = this.min + Math.floor((cappedValue - this.min) / this.step) * this.step;
    this.value = cappedValue <= 0 ? 0 : Math.max(this.min, normalizedValue);
    this.input.value = this.value;
    this.syncControls();
    this.dispatchQuantityChange();
  }

  syncControls() {
    this.minusBtn?.toggleAttribute('disabled', this.value <= 0);
    this.plusBtn?.toggleAttribute('disabled', this.max !== null && this.value + this.step > this.max);
  }

  dispatchQuantityChange() {
    this.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    );
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('item-quantity', ItemQuantity);


//  ================= Side cart drawer (CART REMOVE) =================== //
class ItemRemove extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.line;
    this.anchor = this.querySelector('a.item_remove_btn');
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.anchor?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.anchor?.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    e.preventDefault();

    this.dispatchEvent(
      new CustomEvent('cart-item-remove', {
        detail: {
          value: 0,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('item-remove', ItemRemove);



// ========== CART NOTE ==========
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.textarea = this.querySelector('textarea');
    this.debounceTimer = null;
    this.handleInput = this.handleInput.bind(this);
  }

  connectedCallback() {
    if (this.textarea && this.textarea.value.trim() !== '') {
      this.details.setAttribute('open', '');
    }

    this.textarea?.addEventListener('input', this.handleInput);
  }

  disconnectedCallback() {
    this.textarea?.removeEventListener('input', this.handleInput);
    clearTimeout(this.debounceTimer);
  }

  handleInput() {
    this.details?.setAttribute('open', '');
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.updateCartNote(this.textarea.value.trim());
    }, 500);
  }

  async updateCartNote(value) {
    try {
      await requestCartJson(window.HOM_API_PATHS.cartUpdate, {
        method: 'POST',
        body: JSON.stringify({ note: value })
      });
    } catch (err) {
      console.error('Cart note update failed', err);
    }
  }
}

customElements.define('cart-note', CartNote);

// ========== CART DISCOUNT ==========
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.value = this.input.value;    
    this.btn = this.querySelector('button[name="cart_discount_btn"]');    
    this.remove = this.querySelector('[data-cart-discount-remove]');
    this.error = this.querySelector('.cart_discount_error');
    this.handleInput = this.handleInput.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  connectedCallback() {
    this.input?.addEventListener('input', this.handleInput);
    this.btn?.addEventListener('click', this.handleClick);
    this.remove?.addEventListener('click', this.handleRemove);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.handleInput);
    this.btn?.removeEventListener('click', this.handleClick);
    this.remove?.removeEventListener('click', this.handleRemove);
  }

  handleInput() {
    if(this.error) {
      this.error.classList.add('hidden');
    }
    this.value = this.input.value.trim();
  }

  handleClick(e) {
    e.preventDefault();

    if(!this.value) {
      if(this.error) {
        this.error.classList.remove('hidden');
        this.input.focus();
        return;
      }
    }

    this.dispatchEvent(
      new CustomEvent('discount-btn-click', {
        detail: {
          discount: this.value,          
        },
        bubbles: true, 
        composed: true
      })
    )
  }

  handleRemove(e) {
    e.preventDefault();

    this.dispatchEvent(
      new CustomEvent('discount-remove-click', {
        detail: {
          discount: ''
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('cart-discount-code', CartDiscount);


//  ================= Side cart drawer (MAIN CART CODE) =================== //

class CartItemRemovalAnimator {
  constructor({ duration = 320, timeoutBuffer = 80, motionPreference = window.matchMedia.bind(window) } = {}) {
    this.duration = duration;
    this.timeoutBuffer = timeoutBuffer;
    this.motionPreference = motionPreference;
  }

  animate(itemElement) {
    if (!this.shouldAnimate(itemElement)) return Promise.resolve();

    itemElement.style.setProperty('--cart-item-removal-duration', `${this.duration}ms`);
    itemElement.style.height = `${itemElement.getBoundingClientRect().height}px`;
    // Flush the measured height before starting the transition to zero.
    itemElement.getBoundingClientRect();
    itemElement.classList.add('cart-item-removing');

    return this.waitForHeightTransition(itemElement);
  }

  shouldAnimate(itemElement) {
    return Boolean(
      itemElement &&
      !itemElement.classList.contains('cart-item-removing') &&
      !this.motionPreference('(prefers-reduced-motion: reduce)').matches
    );
  }

  waitForHeightTransition(itemElement) {
    return new Promise((resolve) => {
      let timeoutId;
      const finish = () => {
        clearTimeout(timeoutId);
        itemElement.removeEventListener('transitionend', handleTransitionEnd);
        resolve();
      };
      const handleTransitionEnd = (event) => {
        if (event.target === itemElement && event.propertyName === 'height') finish();
      };

      itemElement.addEventListener('transitionend', handleTransitionEnd);
      timeoutId = setTimeout(finish, this.duration + this.timeoutBuffer);
    });
  }
}

class CartLineRepository {
  constructor({ request = requestCartJson, paths = window.HOM_API_PATHS } = {}) {
    this.request = request;
    this.paths = paths;
  }

  update(line, quantity) {
    return this.request(this.paths.cartChange, {
      method: 'POST',
      body: JSON.stringify({
        line,
        quantity,
        sections: 'cart-drawer,cart,cart-bubble'
      })
    });
  }

  getSections() {
    return this.request(this.paths.cartSections);
  }
}

class CartContents extends HTMLElement {
  constructor({
    lineRepository = new CartLineRepository(),
    removalAnimator = new CartItemRemovalAnimator(),
    eventTarget = document
  } = {}) {
    super();
    this.lineRepository = lineRepository;
    this.removalAnimator = removalAnimator;
    this.eventTarget = eventTarget;
    this.onQtyChange = this.onQtyChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDiscountRemove = this.handleDiscountRemove.bind(this);
    this.inner = this.querySelector('.cart_sidebar_inner') || this.querySelector('.cart_main_content');    
  }

  connectedCallback() {    
    this.eventTarget.addEventListener('cart-quantity-change', this.onQtyChange);
    this.eventTarget.addEventListener('cart-item-remove', this.handleRemove);
    this.eventTarget.addEventListener('discount-btn-click', this.handleClick);
    this.eventTarget.addEventListener('discount-remove-click', this.handleDiscountRemove);
    this.eventTarget.addEventListener('cart-update', updateCart);
  }

  disconnectedCallback() {
    this.eventTarget.removeEventListener('cart-quantity-change', this.onQtyChange);
    this.eventTarget.removeEventListener('cart-item-remove', this.handleRemove);
    this.eventTarget.removeEventListener('discount-btn-click', this.handleClick);
    this.eventTarget.removeEventListener('discount-remove-click', this.handleDiscountRemove);
    this.eventTarget.removeEventListener('cart-update', updateCart);
  }

  onQtyChange(e) {
    if (!this.contains(e.target)) return;
    this.updateLineQuantity({
      ...e.detail,
      itemElement: e.target.closest('.main_cart_item')
    });
  }

  handleRemove(e) {
    if (!this.contains(e.target)) return;
    this.updateLineQuantity({
      ...e.detail,
      itemElement: e.target.closest('.main_cart_item')
    });
  }

  async updateLineQuantity({ value, line, itemElement }) {
    this.inner?.classList.add('loading');

    try {
      const updateRequest = this.lineRepository.update(line, value);
      const removalAnimation = Number(value) === 0
        ? this.removalAnimator.animate(itemElement)
        : Promise.resolve();
      const [data] = await Promise.all([updateRequest, removalAnimation]);

      this.dispatchCartUpdate(data);
    } catch (error) {
      try {
        const sections = await this.lineRepository.getSections();
        this.dispatchCartUpdate({
          line,
          message: error?.message || error?.description || 'Unable to update cart quantity.',
          sections
        });
      } catch (refreshError) {
        console.error('Cart refresh failed:', refreshError);
      }
    } finally {
      this.inner?.classList.remove('loading');
    }
  }

  dispatchCartUpdate(detail) {
    this.eventTarget.dispatchEvent(new CustomEvent('cart-update', { detail, bubbles: true }));
  }

  handleClick(e) {
    if (!this.contains(e.target)) return;

    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(window.HOM_API_PATHS.cartUpdate, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      if(data.discount_codes?.[0]?.applicable === false) {
        const error = this.querySelector('.cart_discount_error');
        
        if(error) {
          error.classList.remove('hidden');
          const input = this.querySelector('input[name="discount"]');
          if (input) input.value = '';
        }

        if(this.inner) {
          this.inner.classList.remove('loading');
        }
      } else {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: data,
            bubbles: true
          })
        )
      }      
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.inner?.classList.remove('loading');
    })
  }

  handleDiscountRemove(e) {
    if (!this.contains(e.target)) return;

    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(window.HOM_API_PATHS.cartUpdate, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'        
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail:data,
          bubble: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      if(this.inner) {
        this.inner.classList.remove('loading');
      }
    })
  }
}

customElements.define('cart-contents', CartContents);

// ==================== CART INDICATORS ==================== //
class CartIndicatorPresenter {
  constructor({
    root = document,
    parseMarkup = (markup) => new DOMParser().parseFromString(markup, 'text/html'),
    logger = console
  } = {}) {
    this.root = root;
    this.parseMarkup = parseMarkup;
    this.logger = logger;
  }

  render({ markup, itemCount } = {}) {
    const newBubble = this.getBubble(markup);

    if (newBubble) {
      this.root.querySelectorAll('.cart-count-text').forEach((oldBubble) => {
        this.updateBubbleText(oldBubble, newBubble);
      });
    }

    const resolvedCount = this.normalizeCount(itemCount) ?? this.normalizeCount(newBubble?.dataset.cartCount);
    if (resolvedCount === null) return;

    this.root.querySelectorAll('.floating_cart_button').forEach((button) => {
      const isEmpty = resolvedCount === 0;
      button.dataset.cartEmpty = String(isEmpty);
      button.toggleAttribute('aria-hidden', isEmpty);
      button.toggleAttribute('inert', isEmpty);
    });
  }

  updateBubbleText(currentBubble, newBubble) {
    const currentCount = currentBubble.querySelector('.cc_text');
    const newCount = newBubble.querySelector('.cc_text');
    const currentAccessibleCount = currentBubble.querySelector('.visually-hidden');
    const newAccessibleCount = newBubble.querySelector('.visually-hidden');

    if (currentCount && newCount && currentCount.textContent !== newCount.textContent) {
      currentCount.textContent = newCount.textContent;
    }
    if (currentAccessibleCount && newAccessibleCount && currentAccessibleCount.textContent !== newAccessibleCount.textContent) {
      currentAccessibleCount.textContent = newAccessibleCount.textContent;
    }
    if (newBubble.dataset.cartCount !== undefined) {
      currentBubble.dataset.cartCount = newBubble.dataset.cartCount;
    }
  }

  getBubble(markup) {
    if (typeof markup !== 'string' || markup.trim() === '') return null;

    try {
      return this.parseMarkup(markup).querySelector('.cart-count-text');
    } catch (error) {
      this.logger.error('Unable to parse cart indicator markup:', error);
      return null;
    }
  }

  normalizeCount(value) {
    if (typeof value === 'string') {
      const normalizedValue = value.trim();
      if (!/^\d+$/.test(normalizedValue)) return null;
      value = normalizedValue;
    } else if (typeof value !== 'number') {
      return null;
    }

    const count = Number(value);
    return Number.isSafeInteger(count) && count >= 0 ? count : null;
  }
}

const cartIndicatorPresenter = new CartIndicatorPresenter();

function updateCartIndicators(markup, itemCount, presenter = cartIndicatorPresenter) {
  presenter.render({ markup, itemCount });
}

// ==================== GENERIC PAGE LIFECYCLE REFRESH ==================== //
class RefreshCoordinator {
  constructor({ logger = console } = {}) {
    this.logger = logger;
    this.subscribers = new Set();
    this.inFlight = null;
  }

  subscribe(refresh) {
    if (typeof refresh !== 'function') throw new TypeError('Lifecycle refresh subscriber must be a function.');

    this.subscribers.add(refresh);
    return () => this.subscribers.delete(refresh);
  }

  refresh() {
    if (this.inFlight) return this.inFlight;

    const refreshes = Array.from(this.subscribers, (refresh) => Promise.resolve()
      .then(refresh)
      .catch((error) => {
        this.logger.warn('Unable to refresh lifecycle subscriber:', error);
        return false;
      }));

    this.inFlight = Promise.all(refreshes)
      .finally(() => {
        this.inFlight = null;
      });

    return this.inFlight;
  }
}

class PageLifecycleObserver {
  constructor({
    documentTarget = document,
    windowTarget = window,
    onResume = () => {}
  } = {}) {
    this.documentTarget = documentTarget;
    this.windowTarget = windowTarget;
    this.onResume = onResume;
    this.started = false;
    this.onFocus = this.onFocus.bind(this);
    this.onPageShow = this.onPageShow.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  start() {
    if (this.started) return;

    this.started = true;
    this.windowTarget.addEventListener('focus', this.onFocus);
    this.windowTarget.addEventListener('pageshow', this.onPageShow);
    this.documentTarget.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  stop() {
    if (!this.started) return;

    this.started = false;
    this.windowTarget.removeEventListener('focus', this.onFocus);
    this.windowTarget.removeEventListener('pageshow', this.onPageShow);
    this.documentTarget.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  onFocus() {
    if (this.documentTarget.visibilityState !== 'hidden') this.onResume();
  }

  onPageShow(event) {
    if (event.persisted) this.onResume();
  }

  onVisibilityChange() {
    if (this.documentTarget.visibilityState === 'visible') this.onResume();
  }
}

// ==================== CART LIFECYCLE ADAPTER ==================== //
class CartIndicatorRefresher {
  constructor({
    loadSections = () => requestCartJson(window.HOM_API_PATHS.cartSections, { cache: 'no-store' }),
    presenter = cartIndicatorPresenter
  } = {}) {
    this.loadSections = loadSections;
    this.presenter = presenter;
  }

  async refresh() {
    const sections = await this.loadSections();
    const markup = sections && typeof sections === 'object' ? sections['cart-bubble'] : null;
    if (typeof markup !== 'string') return false;

    this.presenter.render({ markup });
    return true;
  }
}

const pageResumeRefresh = new RefreshCoordinator();
const cartIndicatorRefresher = new CartIndicatorRefresher();
pageResumeRefresh.subscribe(() => cartIndicatorRefresher.refresh());

const pageLifecycleObserver = new PageLifecycleObserver({
  onResume: () => pageResumeRefresh.refresh()
});
pageLifecycleObserver.start();

function updateCart(e) {
  const data = e?.detail ?? {};
  const sections = data.sections ?? {};
  const updatedDrawer = sections['cart-drawer'];
  const updatedCartPage = sections['cart'];
  const updatedCartBubble = sections['cart-bubble'];
  const errorMsg = data.message;
  const line = data.line;
  const parser = new DOMParser();

  // ========== CART DRAWER UPDATE ==========
  if (updatedDrawer) {
    const parsed = parser.parseFromString(updatedDrawer, 'text/html');

    //  Target drawer specifically by its inner class
    const allCartContents = document.querySelectorAll('cart-contents');
    let drawerEl = null;

    allCartContents.forEach(el => {
      if (el.querySelector('.cart_sidebar_inner') || el.querySelector('.cart_sidebar_content_wrapper')) {
        drawerEl = el;
      }
    });

    if (drawerEl) {
      const selectors = [
        '.cart_sidebar_header h4',
        '.cart_sidebar_content_wrapper',
        '.cart_sidebar_items_footer'
      ];

      selectors.forEach(sel => {
        const oldEl = drawerEl.querySelector(sel);
        const newEl = parsed.querySelector(sel);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      });

      if (errorMsg && line) {
        const errorWrapper = drawerEl.querySelector(`.cart_error[data-line="${line}"]`);
        if (errorWrapper) {
          errorWrapper.innerHTML = `<p>${errorMsg}</p>`;
          errorWrapper.removeAttribute('hidden');
        }
      }
    }
  }

  // ========== MAIN CART PAGE UPDATE ==========
  if (updatedCartPage) {
    const parsed = parser.parseFromString(updatedCartPage, 'text/html');

    //  Target cart page specifically by its inner class
    const allCartContents = document.querySelectorAll('cart-contents');
    let cartPageEl = null;

    allCartContents.forEach(el => {
      if (el.querySelector('.cart_main_content') || el.querySelector('.cart_main_header')) {
        cartPageEl = el;
      }
    });

    if (cartPageEl) {
      const selectors = [
        '.cart_main_header',
        '.cart_main_content'
      ];

      selectors.forEach(sel => {
        const oldEl = cartPageEl.querySelector(sel);
        const newEl = parsed.querySelector(sel);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      });

      //  Handle empty cart state
      const hasNewContent = parsed.querySelector('.cart_main_content');
      if (!hasNewContent) {
        // Cart is now empty — find your empty state element in new HTML
        // and replace the entire inner content
        const cartBody = parsed.querySelector('body');
        if (cartBody) {
          cartPageEl.innerHTML = cartBody.innerHTML;
        }
      }

      if (errorMsg && line) {
        const errorBox = cartPageEl.querySelector(`.cart_error[data-line="${line}"]`);
        if (errorBox) {
          errorBox.innerHTML = `<p>${errorMsg}</p>`;
          errorBox.hidden = false;
        }
      }
    }
  }

  // ========== CART BUBBLE UPDATE ==========
  updateCartIndicators(updatedCartBubble, data.item_count);
}





  /* ======================================================================
   COLLECTION page Filter code Component 
====================================================================== */


// ==================== INFINITE SCROLL   ==================== //

function appendListingItems(grid, items) {
  let firstUnavailable = Array.from(grid.children).find(item => item.dataset.productAvailable === "false");
  items.forEach(item => {
    if (firstUnavailable && item.dataset.productAvailable === "true") {
      grid.insertBefore(item, firstUnavailable);
    } else {
      grid.appendChild(item);
      if (!firstUnavailable && item.dataset.productAvailable === "false") firstUnavailable = item;
    }
  });
}

class InfiniteScroll extends HTMLElement {
  constructor({
    appendItems = appendListingItems,
    repository = new window.HOMSectionRequests.PaginationRepository(),
    retryPolicy = new window.HOMSectionRequests.RetryPolicy(),
  } = {}) {
    super();
    Object.assign(this, { repository, retryPolicy, appendItems });
    this.onClick = this.onClick.bind(this);
    this.onListingUpdate = this.onListingUpdate.bind(this);
    this.onListingFailure = this.onListingFailure.bind(this);
    this.onOnline = this.onOnline.bind(this);
    this.onOffline = this.onOffline.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector(".infinite-scroll--next");
    this.section = this.closest("[data-pagination-scope], .shopify-section");
    this.sectionId = this.dataset.sectionId;
    this.button?.addEventListener("click", this.onClick);
    this.section?.addEventListener("listing:updating", this.onListingUpdate);
    this.section?.addEventListener("listing:update-failed", this.onListingFailure);
    this.status = this.querySelector("[data-pagination-status]");
    this.error = this.querySelector("[data-pagination-error]");
    this.refreshLink = this.querySelector("[data-pagination-refresh]");
    this.label = this.button?.querySelector(".load_more");
    this.gridSelector = this.dataset.gridSelector || ".main_collection_grid";
    this.itemSelector = this.dataset.itemSelector || ".collection-grid_wrapper";
    this.loadedPages ||= new Set();
    this.suspended = false;
    window.addEventListener("online", this.onOnline);
    window.addEventListener("offline", this.onOffline);
    if (this.dataset.eager === "true") this.loadProducts(true);
    else this.observeNextPage();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.button?.removeEventListener("click", this.onClick);
    this.section?.removeEventListener("listing:updating", this.onListingUpdate);
    this.section?.removeEventListener("listing:update-failed", this.onListingFailure);
    window.removeEventListener("online", this.onOnline);
    window.removeEventListener("offline", this.onOffline);
    this.cancelRequest();
  }

  onClick(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.loadProducts();
  }

  onListingUpdate() {
    this.suspended = true;
    this.observer?.disconnect();
    this.cancelRequest();
  }

  onListingFailure(event) {
    if (event?.detail?.preserveResults) {
      this.suspended = false;
      this.observeNextPage();
      return;
    }
    // The URL may now describe different results. Refresh instead of appending the old query.
    this.hidden = false;
    this.showError(this.paginationError('invalid'));
    if (this.button) this.button.hidden = true;
  }

  observeNextPage() {
    if (this.suspended || this.errorCode || !this.button?.getAttribute("href") || !window.IntersectionObserver) return;
    if (!this.observer) {
      this.observer = new window.IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadProducts(true);
      }, { rootMargin: "0px 0px 1600px 0px" });
    }
    this.observer.observe(this);
  }

  onOffline() {
    if (this.suspended || !this.button?.getAttribute("href")) return;
    this.resumeOnOnline = Boolean(this.request);
    this.observer?.disconnect();
    this.cancelRequest();
    this.showError(this.paginationError("offline"));
  }

  onOnline() {
    if (!this.isConnected || this.suspended || this.errorCode !== "offline") return;
    const resume = this.resumeOnOnline;
    this.resumeOnOnline = false;
    this.clearError();
    if (resume) this.loadProducts();
    else this.observeNextPage();
  }

  paginationError(code, retryable = false, retryAfterMs = 0) {
    return new window.HOMSectionRequests.RequestError(code, retryable, retryAfterMs);
  }

  showError(error) {
    this.errorCode = error.code || "network";
    if (this.error) {
      this.error.textContent = this.dataset[`${this.errorCode}Message`] || this.dataset.errorMessage;
      this.error.hidden = false;
    }
    if (this.status) this.status.textContent = "";
    if (this.label) this.label.textContent = this.dataset.retryMessage;
    if (this.refreshLink) {
      this.refreshLink.href = window.location.href;
      this.refreshLink.hidden = !["session", "unavailable", "invalid"].includes(this.errorCode);
    }
  }

  clearError() {
    this.errorCode = null;
    if (this.error) this.error.hidden = true;
    if (this.refreshLink) this.refreshLink.hidden = true;
    if (this.label) this.label.textContent = this.dataset.loadMoreMessage;
  }

  cancelRequest() {
    this.request?.controller.abort();
    this.request = null;
    this.setLoading(false);
  }

  isCurrentRequest(request) {
    return this.request === request && this.isConnected &&
      !request.controller.signal.aborted && this.collectionLocation() === request.location;
  }

  collectionLocation() {
    const url = new URL(window.location.href);
    return url.pathname + url.search;
  }

  async loadProducts(automatic = false) {
    const nextUrl = this.button?.getAttribute("href");
    if (!nextUrl || this.request || !this.section || this.suspended || (automatic && this.errorCode)) return;
    this.observer?.disconnect();
    if (navigator.onLine === false) {
      this.resumeOnOnline = true;
      this.showError(this.paginationError("offline"));
      return;
    }
    if (Date.now() < this.retryPolicy.availableAt) return;

    let url;
    try {
      url = new URL(nextUrl, window.location.origin);
    } catch (error) {
      this.showError(this.paginationError("invalid"));
      return;
    }
    const request = {
      controller: new AbortController(),
      location: this.collectionLocation(),
      url,
    };
    if (request.url.origin !== window.location.origin || this.loadedPages.has(request.url.href)) {
      this.showError(this.paginationError("invalid"));
      return;
    }
    this.request = request;
    this.clearError();
    this.setLoading(true);
    let loaded = false;

    try {
      const page = await this.retryPolicy.execute(() => this.repository.get({
        url: request.url, sectionId: this.sectionId, signal: request.controller.signal,
      }), {
        signal: request.controller.signal,
        shouldContinue: () => this.isCurrentRequest(request),
        onRetry: () => {
          if (this.status) this.status.textContent = this.dataset.retryingMessage;
        },
      });
      if (!this.isCurrentRequest(request)) return;
      this.appendPage(page, request.url);
      this.loadedPages.add(request.url.href);
      loaded = true;
    } catch (error) {
      if (this.isCurrentRequest(request)) {
        this.resumeOnOnline = error.code === "offline";
        this.showError(error);
      }
    } finally {
      if (this.request === request) {
        this.request = null;
        this.setLoading(false);
        if (loaded) this.observeNextPage();
      }
    }
  }

  appendPage(page, url) {
    const incoming = page.querySelector(this.gridSelector);
    const grid = this.section.querySelector(this.gridSelector);
    if (!incoming || !grid) throw this.paginationError("invalid");
    const items = incoming.querySelectorAll(this.itemSelector);
    const nextLink = page.querySelector(`infinite-scroll[data-grid-selector="${this.gridSelector}"] .infinite-scroll--next`);
    const nextHref = nextLink?.getAttribute("href");
    if (nextHref) {
      let nextUrl;
      try {
        nextUrl = new URL(nextHref, window.location.origin);
      } catch (error) {
        throw this.paginationError("invalid");
      }
      if (!items.length || nextUrl.origin !== window.location.origin || nextUrl.href === url.href || this.loadedPages.has(nextUrl.href)) {
        throw this.paginationError("invalid");
      }
    }
    items.forEach(item => { item.dataset.revealed = "false"; });
    this.appendItems(grid, items);
    this.updateNextLink(nextLink);
    if (this.status) this.status.textContent = nextHref
      ? this.dataset.loadedMessage.replace("[count]", items.length)
      : "";
    if (typeof initProductCardSliders === "function") initProductCardSliders(grid);
    this.revealProducts(items);
    document.dispatchEvent(new CustomEvent("collection-grid-update", {
      detail: { url, sectionId: this.sectionId },
    }));
    document.dispatchEvent(new CustomEvent("pagination:loaded", {
      detail: { url, sectionId: this.sectionId, items: Array.from(items) },
    }));
  }

  updateNextLink(nextLink) {
    const href = nextLink?.getAttribute("href");
    if (href) this.button.setAttribute("href", href);
    else {
      this.button.removeAttribute("href");
      this.button.remove();
      this.observer?.disconnect();
      this.hidden = true;
    }
  }

  revealProducts(items) {
    if (!window.scrollReveal) return;
    const revealItems = Array.from(items)
      .map((item) => item.querySelector(".reveal.stagger"))
      .filter(Boolean);
    window.scrollReveal.staggerBatch(revealItems);
  }

  setLoading(loading) {
    if (loading && this.status) this.status.textContent = this.dataset.loadingMessage;
    this.button?.querySelector(".load_more")?.classList.toggle("hidden", loading);
    this.button?.querySelector(".pagination_loader")?.classList.toggle("hidden", !loading);
    if (loading) this.button?.setAttribute("aria-busy", "true");
    else this.button?.removeAttribute("aria-busy");
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
 
// ============ FILTER OPEN / CLOSE  ============ //

class FilterPanelView {
  constructor({ drawer, triggers, isSidebarVisible, body, html }) {
    Object.assign(this, { drawer, triggers, isSidebarVisible, body, html });
    this.scrollState = null;
  }

  render(open) {
    this.drawer.classList.toggle('is-active', open);
    this.drawer.toggleAttribute('inert', !open && !this.isSidebarVisible());
    this.drawer.setAttribute('aria-hidden', String(!open && !this.isSidebarVisible()));
    for (const trigger of this.triggers) {
      trigger.setAttribute('aria-expanded', String(open));
      trigger.setAttribute('aria-haspopup', 'dialog');
      if (this.drawer.id) trigger.setAttribute('aria-controls', this.drawer.id);
    }
    if (open) {
      this.drawer.setAttribute('role', 'dialog');
      this.drawer.setAttribute('aria-modal', 'true');
      const label = this.triggers[0];
      this.drawer.setAttribute('aria-label', label?.getAttribute('aria-label') || label?.textContent.trim() || '');
      if (!this.scrollState) {
        this.scrollState = {
          lock: this.body.getAttribute('data-scroll-locked'),
          stopped: this.html.classList.contains('lenis-stopped'),
        };
      }
      this.body.setAttribute('data-scroll-locked', 'true');
      this.html.classList.add('lenis-stopped');
    } else {
      this.drawer.removeAttribute('role');
      this.drawer.removeAttribute('aria-modal');
      this.drawer.removeAttribute('aria-label');
      if (this.scrollState) {
        if (this.scrollState.lock === null) this.body.removeAttribute('data-scroll-locked');
        else this.body.setAttribute('data-scroll-locked', this.scrollState.lock);
        this.html.classList.toggle('lenis-stopped', this.scrollState.stopped);
        this.scrollState = null;
      }
    }
  }

  revealFilter(param) {
    const details = [...this.drawer.querySelectorAll('details[data-filter-param]')]
      .find((element) => element.dataset.filterParam === param);
    if (!details) return null;
    details.open = true;
    const content = details.closest('.c_filters_content');
    if (content) {
      const top = content.scrollTop + details.getBoundingClientRect().top - content.getBoundingClientRect().top;
      content.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    return details.querySelector('summary');
  }
}

class FilterPanelFocus {
  constructor({ drawer, document }) {
    Object.assign(this, { drawer, document });
    this.returnTarget = null;
  }

  elements() {
    const selector = 'a[href], button:not(:disabled), input:not(:disabled):not([type="hidden"]), textarea:not(:disabled), select:not(:disabled), summary, [tabindex]';
    return [...this.drawer.querySelectorAll(selector)].filter((element) =>
      element.tabIndex >= 0 && element.getClientRects().length > 0 &&
      this.document.defaultView.getComputedStyle(element).visibility !== 'hidden');
  }

  focus(element) {
    element?.focus({ preventScroll: true });
  }

  enter(trigger) {
    this.returnTarget = trigger || this.document.activeElement;
    this.focus(this.elements()[0] || this.drawer.querySelector('.collection_drawer-wrapper_inner'));
  }

  restore() {
    if (this.returnTarget?.isConnected) this.focus(this.returnTarget);
    this.returnTarget = null;
  }

  trap(event) {
    if (event.key !== 'Tab') return;
    const elements = this.elements();
    const first = elements[0];
    const last = elements[elements.length - 1];
    const active = this.document.activeElement;
    if (!first || !elements.includes(active) || (event.shiftKey ? active === first : active === last)) {
      event.preventDefault();
      this.focus((event.shiftKey ? last : first) || this.drawer.querySelector('.collection_drawer-wrapper_inner'));
    }
  }
}

class FilterPanelController {
  constructor({ root, drawer, view, focus, media, document, requestFrame, cancelFrame }) {
    Object.assign(this, { root, drawer, view, focus, media, document, requestFrame, cancelFrame });
    this.connected = false;
    this.opened = false;
    this.pendingFrame = null;
    this.onClick = (event) => {
      const trigger = event.target.closest('.collection_filter_icon, [data-filter-param-button]');
      if (trigger && this.root.contains(trigger)) {
        this.open(trigger);
        const param = trigger.dataset.filterParamButton;
        if (param) this.reveal(param);
      } else if (event.target === this.drawer || event.target.closest('.c_drawer_close')) {
        this.close();
      }
    };
    this.onKeydown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else this.focus.trap(event);
    };
    this.onMediaChange = () => this.close();
  }

  connect() {
    if (this.connected) return;
    this.connected = true;
    this.view.render(false);
    this.root.addEventListener('click', this.onClick);
    this.media.addEventListener('change', this.onMediaChange);
  }

  open(trigger) {
    if (!this.connected || this.opened) return;
    this.opened = true;
    this.view.render(true);
    this.focus.enter(trigger);
    this.document.addEventListener('keydown', this.onKeydown);
  }

  reveal(param) {
    this.cancelReveal();
    const revision = this.revealRevision;
    this.pendingFrame = this.requestFrame(() => {
      if (revision !== this.revealRevision) return;
      this.pendingFrame = null;
      if (this.opened && this.root.isConnected) this.focus.focus(this.view.revealFilter(param));
    });
  }

  cancelReveal() {
    this.revealRevision = (this.revealRevision || 0) + 1;
    if (this.pendingFrame !== null) this.cancelFrame(this.pendingFrame);
    this.pendingFrame = null;
  }

  close({ restoreFocus = true } = {}) {
    this.cancelReveal();
    const wasOpen = this.opened;
    this.opened = false;
    this.document.removeEventListener('keydown', this.onKeydown);
    this.view.render(false);
    if (wasOpen && restoreFocus) this.focus.restore();
  }

  disconnect() {
    if (!this.connected) return;
    this.close({ restoreFocus: false });
    this.root.removeEventListener('click', this.onClick);
    this.media.removeEventListener('change', this.onMediaChange);
    this.connected = false;
  }
}

class SelectFocusController {
  constructor({ select, dropdown }) {
    Object.assign(this, { select, dropdown });
    this.connected = false;
    this.onPointer = () => this.dropdown?.classList.add('is-pointer-focused');
    this.onKeyboard = () => this.dropdown?.classList.remove('is-pointer-focused');
  }

  connect() {
    if (this.connected) return;
    this.connected = true;
    this.select.addEventListener('pointerdown', this.onPointer);
    this.select.addEventListener('keydown', this.onKeyboard);
    this.select.addEventListener('blur', this.onKeyboard);
  }

  disconnect() {
    if (!this.connected) return;
    this.select.removeEventListener('pointerdown', this.onPointer);
    this.select.removeEventListener('keydown', this.onKeyboard);
    this.select.removeEventListener('blur', this.onKeyboard);
    this.onKeyboard();
    this.connected = false;
  }
}

function sortMenuPlacement({ anchor, viewport, menuWidth, desiredHeight, gutter = 16, gap = 8, maximumHeight = 420 }) {
  const below = Math.max(0, viewport.height - anchor.bottom - gap - gutter);
  const above = Math.max(0, anchor.top - gap - gutter);
  const placeBelow = below >= Math.min(desiredHeight, maximumHeight) || below >= above;
  const maxHeight = Math.min(maximumHeight, placeBelow ? below : above);
  const height = Math.min(desiredHeight, maxHeight);
  return {
    left: Math.max(gutter, Math.min(anchor.left, viewport.width - menuWidth - gutter)),
    top: placeBelow ? anchor.bottom + gap : Math.max(gutter, anchor.top - height - gap),
    maxHeight,
  };
}

class SortMenuView {
  constructor({ select, trigger, menu, dropdown, document, browser, place = sortMenuPlacement }) {
    Object.assign(this, { select, trigger, menu, dropdown, document, browser, place });
  }

  render() {
    const buttons = [...this.select.options].map((option) => {
      const button = this.document.createElement('button');
      button.type = 'button';
      button.role = 'menuitemradio';
      button.dataset.sortValue = option.value;
      button.textContent = option.textContent.trim();
      button.disabled = option.disabled;
      button.tabIndex = -1;
      button.setAttribute('aria-checked', String(option.value === this.select.value));
      return button;
    });
    this.menu.replaceChildren(...buttons);
    this.syncSelection();
  }

  syncSelection() {
    for (const button of this.menu.querySelectorAll('[data-sort-value]')) {
      button.setAttribute('aria-checked', String(button.dataset.sortValue === this.select.value));
    }
    const current = this.trigger.querySelector('[data-sort-current]');
    if (current) current.textContent = this.select.selectedOptions[0]?.textContent.trim() || '';
    this.trigger.disabled = this.select.disabled || this.select.options.length === 0;
  }

  enhance(enabled) {
    this.select.hidden = enabled;
    this.trigger.hidden = !enabled;
    this.dropdown.classList.toggle('is-enhanced', enabled);
  }

  isOpen() {
    return this.menu.matches(':popover-open');
  }

  open() {
    this.render();
    this.menu.showPopover();
    this.position();
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (this.isOpen()) this.menu.hidePopover();
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  position() {
    const placement = this.place({
      anchor: this.trigger.getBoundingClientRect(),
      viewport: { width: this.document.documentElement.clientWidth, height: this.browser.innerHeight },
      menuWidth: this.menu.getBoundingClientRect().width,
      desiredHeight: this.menu.scrollHeight + this.menu.offsetHeight - this.menu.clientHeight,
    });
    for (const [name, value] of Object.entries(placement)) this.menu.style[name] = `${value}px`;
  }

  items() {
    return [...this.menu.querySelectorAll('[data-sort-value]:not(:disabled)')];
  }

  focus(item) {
    item?.focus({ preventScroll: true });
    if (!item) return;
    const itemRect = item.getBoundingClientRect();
    const menuRect = this.menu.getBoundingClientRect();
    if (itemRect.top < menuRect.top) this.menu.scrollTop -= menuRect.top - itemRect.top;
    else if (itemRect.bottom > menuRect.bottom) this.menu.scrollTop += itemRect.bottom - menuRect.bottom;
  }
}

class SortMenuController {
  constructor({ select, trigger, menu, view, document, browser, onChoose, now = () => Date.now() }) {
    Object.assign(this, { select, trigger, menu, view, document, browser, onChoose, now });
    this.connected = false;
    this.search = '';
    this.lastTyped = 0;
    this.onTriggerClick = () => this.view.isOpen() ? this.close() : this.open();
    this.onTriggerKey = (event) => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.open(event.key === 'ArrowUp' ? 'last' : 'first');
    };
    this.onMenuClick = (event) => {
      const option = event.target.closest('[data-sort-value]');
      if (!option || option.disabled || !this.menu.contains(option)) return;
      const value = option.dataset.sortValue;
      this.close();
      if (value !== this.select.value) this.onChoose(value);
    };
    this.onMenuKey = (event) => this.handleKey(event);
    this.onToggle = () => this.trigger.setAttribute('aria-expanded', String(this.view.isOpen()));
    this.onSourceChange = () => this.view.syncSelection();
    this.onViewportChange = (event) => {
      if (event.type === 'resize' || !this.menu.contains(event.target)) this.close(false);
    };
  }

  connect() {
    if (this.connected) return;
    this.connected = true;
    this.view.enhance(true);
    this.view.syncSelection();
    this.trigger.addEventListener('click', this.onTriggerClick);
    this.trigger.addEventListener('keydown', this.onTriggerKey);
    this.menu.addEventListener('click', this.onMenuClick);
    this.menu.addEventListener('keydown', this.onMenuKey);
    this.menu.addEventListener('toggle', this.onToggle);
    this.select.addEventListener('change', this.onSourceChange);
    this.browser.addEventListener('resize', this.onViewportChange);
    this.document.addEventListener('scroll', this.onViewportChange, true);
  }

  open(edge) {
    if (!this.connected || this.select.disabled || this.select.options.length === 0) return;
    this.search = '';
    this.view.open();
    const items = this.view.items();
    const selected = items.find((item) => item.dataset.sortValue === this.select.value);
    this.view.focus(edge === 'last' ? items.at(-1) : edge === 'first' ? items[0] : selected || items[0]);
  }

  close(restoreFocus = true) {
    const open = this.view.isOpen();
    this.view.close();
    if (open && restoreFocus && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
  }

  handleKey(event) {
    if (event.key === 'Escape' || event.key === 'Tab') {
      if (event.key === 'Escape') event.preventDefault();
      this.close();
      return;
    }
    const items = this.view.items();
    if (!items.length) return;
    const index = items.indexOf(this.document.activeElement);
    let next;
    if (event.key === 'ArrowDown') next = items[(index + 1) % items.length];
    else if (event.key === 'ArrowUp') next = items[(index - 1 + items.length) % items.length];
    else if (event.key === 'Home') next = items[0];
    else if (event.key === 'End') next = items.at(-1);
    else if (event.key.length === 1 && /\S/.test(event.key) && !event.ctrlKey && !event.altKey && !event.metaKey) {
      const time = this.now();
      this.search = (time - this.lastTyped < 600 ? this.search : '') + event.key.toLocaleLowerCase();
      this.lastTyped = time;
      const prefix = [...this.search].every(char => char === this.search[0]) ? this.search[0] : this.search;
      const keepCurrent = prefix.length > 1 && items[index]?.textContent.toLocaleLowerCase().startsWith(prefix);
      const ordered = keepCurrent ? [items[index]] : [...items.slice(index + 1), ...items.slice(0, index + 1)];
      next = ordered.find(item => item.textContent.toLocaleLowerCase().startsWith(prefix));
    }
    if (next) {
      event.preventDefault();
      this.view.focus(next);
    }
  }

  disconnect() {
    if (!this.connected) return;
    this.close(false);
    this.trigger.removeEventListener('click', this.onTriggerClick);
    this.trigger.removeEventListener('keydown', this.onTriggerKey);
    this.menu.removeEventListener('click', this.onMenuClick);
    this.menu.removeEventListener('keydown', this.onMenuKey);
    this.menu.removeEventListener('toggle', this.onToggle);
    this.select.removeEventListener('change', this.onSourceChange);
    this.browser.removeEventListener('resize', this.onViewportChange);
    this.document.removeEventListener('scroll', this.onViewportChange, true);
    this.view.enhance(false);
    this.connected = false;
  }
}

class CollectionWorkspace extends HTMLElement {
  connectedCallback() {
    if (this.filterPanel) return;
    const ownerDocument = this.ownerDocument;
    const browser = ownerDocument.defaultView;
    const query = this.querySelector('[data-mobile-results-query]');
    const sourceQuery = new URLSearchParams(browser.location.search).get('search_query');
    if (query && sourceQuery) query.textContent = sourceQuery;
    const drawer = this.querySelector('.c_filter_drawer');
    if (!drawer) return;
    const media = browser.matchMedia('(min-width: 990px)');
    const view = new FilterPanelView({
      drawer,
      triggers: [...this.querySelectorAll('.collection_filter_icon, [data-filter-param-button]')],
      isSidebarVisible: () => drawer.classList.contains('collection_drawer-wrapper--desktop-sidebar') && media.matches,
      body: ownerDocument.body,
      html: ownerDocument.documentElement,
    });
    this.filterPanel = new FilterPanelController({
      root: this, drawer, view, media, document: ownerDocument,
      focus: new FilterPanelFocus({ drawer, document: ownerDocument }),
      requestFrame: (callback) => browser.requestAnimationFrame(callback),
      cancelFrame: (id) => browser.cancelAnimationFrame(id),
    });
    this.filterPanel.connect();
  }

  disconnectedCallback() {
    this.filterPanel?.disconnect();
    this.filterPanel = null;
  }
}

customElements.define('collection-workspace', CollectionWorkspace);


// ============ SORTING  ============ //
class ListingSortView {
  constructor({ workspace, select, refreshControl, initializeCards }) {
    Object.assign(this, { workspace, select, refreshControl, initializeCards });
    this.appliedValue = select.value;
  }

  setLoading(loading) {
    const loader = this.workspace?.querySelector('.main_collection > .loader, .main_collection_list_wrapper .loader');
    loader?.classList.toggle('hidden', !loading);
    this.select.disabled = loading;
    this.refreshControl();
  }

  render(markup, value) {
    const results = this.workspace?.querySelector('.main_collection');
    if (!results) throw new Error('Missing collection results');
    results.innerHTML = markup;
    this.appliedValue = value;
    this.select.value = value;
    this.refreshControl();
    this.initializeCards(results);
  }

  rollback() {
    this.select.value = this.appliedValue;
    this.refreshControl();
  }
}

class ListingSortController {
  constructor({ repository, view, sectionId, currentUrl, commitUrl, onStart, onSuccess, onFailure,
    makeAbortController = () => new AbortController() }) {
    Object.assign(this, { repository, view, sectionId, currentUrl, commitUrl, onStart, onSuccess, onFailure, makeAbortController });
    this.active = true;
    this.request = null;
  }

  async choose(value) {
    if (!this.active) return;
    this.cancel();
    const request = this.makeAbortController();
    this.request = request;
    const url = new URL(this.currentUrl());
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.searchParams.delete('sections');
    this.onStart();
    this.view.setLoading(true);
    try {
      const markup = await this.repository.get({ url, sectionId: this.sectionId, signal: request.signal });
      if (!this.active || this.request !== request || request.signal.aborted) return;
      this.view.render(markup, value);
      this.commitUrl(url);
      this.onSuccess(url);
    } catch (error) {
      if (!this.active || this.request !== request || request.signal.aborted) return;
      this.view.rollback();
      this.onFailure(error);
    } finally {
      if (this.request === request) {
        this.request = null;
        this.view.setLoading(false);
      }
    }
  }

  cancel({ rollback = false } = {}) {
    if (this.request) {
      this.request.abort();
      this.request = null;
      this.view.setLoading(false);
    }
    if (rollback) this.view.rollback();
  }

  disconnect() {
    this.active = false;
    this.cancel();
    this.view.rollback();
  }
}

class CollectionSorting extends HTMLElement {
  connectedCallback() {
    this.disconnectedCallback();
    this.select = this.querySelector('select[name="sort_by"]');
    if (!this.select) return;
    this.workspace = this.closest('.collection_workspace') || this.parentElement;
    const ownerDocument = this.ownerDocument;
    const browser = ownerDocument.defaultView;
    const trigger = this.querySelector('[data-sort-trigger]');
    const menu = this.querySelector('[data-sort-menu]');
    if (trigger && menu && typeof menu.showPopover === 'function') {
      const view = new SortMenuView({ select: this.select, trigger, menu, dropdown: this.select.closest('.collection_filter_dropdown'), document: ownerDocument, browser });
      this.sortMenu = new SortMenuController({
        select: this.select, trigger, menu, view, document: ownerDocument, browser,
        onChoose: (value) => {
          this.select.value = value;
          this.select.dispatchEvent(new browser.Event('change', { bubbles: true }));
        },
      });
      this.sortMenu.connect();
    } else {
      this.focusController = new SelectFocusController({ select: this.select, dropdown: this.select.closest('.collection_filter_dropdown') });
      this.focusController.connect();
    }
    const view = new ListingSortView({
      workspace: this.workspace,
      select: this.select,
      refreshControl: () => this.syncSortControl(),
      initializeCards: (root) => {
        if (typeof initProductCardSliders === 'function') initProductCardSliders(root);
      },
    });
    this.sorting = new ListingSortController({
      repository: new browser.HOMSectionRequests.ListingSortRepository(),
      view, sectionId: this.dataset.sectionId,
      currentUrl: () => browser.location.href,
      commitUrl: (url) => browser.history.pushState({}, '', url.toString()),
      makeAbortController: () => new browser.AbortController(),
      onStart: () => this.dispatchEvent(new browser.CustomEvent('listing:updating', { bubbles: true })),
      onSuccess: (url) => ownerDocument.dispatchEvent(new browser.CustomEvent('collection-grid-update', { detail: { url, sectionId: this.dataset.sectionId } })),
      onFailure: (error) => {
        this.dispatchEvent(new browser.CustomEvent('listing:update-failed', { bubbles: true, detail: { preserveResults: true } }));
        browser.console.error('Collection sort failed:', error);
      },
    });
    this.onSortChange = () => this.sorting.choose(this.select.value);
    this.onOtherListingUpdate = (event) => {
      if (event.target !== this) this.sorting?.cancel({ rollback: true });
    };
    this.workspace?.addEventListener('listing:updating', this.onOtherListingUpdate);
    this.select.addEventListener('change', this.onSortChange);
    this.syncSortControl();
  }

  syncSortControl() {
    this.sortMenu?.view.syncSelection();
    const label = this.querySelector('.collection_sort_selected');
    if (label) label.textContent = this.select?.selectedOptions[0]?.textContent.trim() || '';
  }

  disconnectedCallback() {
    this.workspace?.removeEventListener('listing:updating', this.onOtherListingUpdate);
    this.sorting?.disconnect();
    this.sorting = null;
    this.sortMenu?.disconnect();
    this.sortMenu = null;
    this.focusController?.disconnect();
    this.focusController = null;
    this.select?.removeEventListener('change', this.onSortChange);
  }
}

customElements.define('product-sorting', CollectionSorting);

// ============ COLLECTION PRODUCT FILTER  ============ //


class Filters extends HTMLElement {
  connectedCallback() {
    this.disconnectListingRequests();
    this.listingWorkspace = this.closest('.collection_workspace') || this.ownerDocument;
    this.uiEvents = new AbortController();
    this.collectionGrid = this.listingWorkspace.querySelector('.main_collection');
    this.btn = this.querySelector('.filters_btn button');
    this.form = this.querySelector('form#c_filters_form');
    this.drawer = this.closest('.c_filter_drawer');
    this.activeValues = this.querySelectorAll('.active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
    this.filterRepository = new this.ownerDocument.defaultView.HOMSectionRequests.SectionRepository();
    this.onOtherListingUpdate = (event) => {
      if (event.target !== this) this.cancelListingRequest();
    };
    this.listingWorkspace?.addEventListener('listing:updating', this.onOtherListingUpdate);
    this.attachListeners();
    this.initPriceRanges();
  }

  cancelListingRequest() {
    this.filterRequest?.abort();
    this.filterRequest = null;
  }

  listen(target, type, callback) {
    target.addEventListener(type, callback, { signal: this.uiEvents.signal });
  }

  disconnectListingRequests() {
    this.uiEvents?.abort();
    window.clearTimeout(this.desktopFilterTimer);
    this.listingWorkspace?.removeEventListener('listing:updating', this.onOtherListingUpdate);
    const wasLoading = Boolean(this.filterRequest);
    this.cancelListingRequest();
    if (wasLoading) this.hideLoader();
  }

  disconnectedCallback() {
    this.disconnectListingRequests();
  }

  initPriceRanges() {
    this.querySelectorAll('.price-filter-range').forEach((range) => {
      const minRange = range.querySelector('.price-filter-range__input--min');
      const maxRange = range.querySelector('.price-filter-range__input--max');
      const minField = this.querySelector(`#${CSS.escape(minRange?.dataset.priceTarget || '')}`);
      const maxField = this.querySelector(`#${CSS.escape(maxRange?.dataset.priceTarget || '')}`);

      if (!minRange || !maxRange || !minField || !maxField) return;

      const updateTrack = () => {
        const maximum = Number(maxRange.max) || 1;
        range.style.setProperty('--range-start', `${(Number(minRange.value) / maximum) * 100}%`);
        range.style.setProperty('--range-end', `${(Number(maxRange.value) / maximum) * 100}%`);
      };

      this.listen(minRange, 'input', () => {
        minRange.value = Math.min(Number(minRange.value), Number(maxRange.value));
        minField.value = minRange.value;
        updateTrack();
      });

      this.listen(maxRange, 'input', () => {
        maxRange.value = Math.max(Number(maxRange.value), Number(minRange.value));
        maxField.value = maxRange.value;
        updateTrack();
      });

      this.listen(minField, 'input', () => {
        minRange.value = Math.min(Number(minField.value || 0), Number(maxRange.value));
        updateTrack();
      });

      this.listen(maxField, 'input', () => {
        maxRange.value = Math.max(Number(maxField.value || maxRange.max), Number(minRange.value));
        updateTrack();
      });

      updateTrack();
    });
  }

  attachListeners() {
    if(this.btn) {
      this.listen(this.btn, 'click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if (this.form && this.closest('.collection_drawer-wrapper--desktop-sidebar')) {
      this.listen(this.form, 'change', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;

        window.clearTimeout(this.desktopFilterTimer);
        this.desktopFilterTimer = window.setTimeout(() => {
          this.showLoader();
          this.submitForm();
        }, 200);
      });
    }

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      this.listen(value, 'click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);

        this.updateURL(url.toString()),
        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = this.listingWorkspace.querySelector('.main_collection > .loader, .main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = this.listingWorkspace.querySelector('.main_collection > .loader, .main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(key === 'page') continue;
      if(!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;

    await this.updateURL(url);
    await this.updatePage(url, this.sectionId);



    
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) {
    this.cancelListingRequest();
    const request = new AbortController();
    this.filterRequest = request;
    this.dispatchEvent(new CustomEvent('listing:updating', { bubbles: true }));
    this.showLoader();
    return this.filterRepository.get({ url: new URL(url, window.location.href), sectionId: id, signal: request.signal })
    .then((temp) => {
      if (this.filterRequest !== request || request.signal.aborted || !this.isConnected) return;


      const newWrapper = temp.querySelector('.main_collection');
      const oldWrapper = this.listingWorkspace.querySelector('.main_collection');
      if (!newWrapper || !oldWrapper) throw new Error('Missing collection results');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML;

        requestAnimationFrame(() => {
          if (typeof initProductCardSliders === 'function') {
            initProductCardSliders(oldWrapper);
          }
        });

      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = this.listingWorkspace.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileCount = temp.querySelector('[data-mobile-results-count]');
      const oldMobileCount = this.listingWorkspace.querySelector('[data-mobile-results-count]');

      if(oldMobileCount && newMobileCount) {
        oldMobileCount.textContent = newMobileCount.textContent;
      }

      const newActiveFilters = temp.querySelector('.collection_active_filters_bar');
      const oldActiveFilters = this.listingWorkspace.querySelector('.collection_active_filters_bar');

      if(oldActiveFilters && newActiveFilters) {
        oldActiveFilters.innerHTML = newActiveFilters.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.c_filter_drawer');
      const oldMobileDrawer = this.drawer;

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .catch((error) => {
      if (this.filterRequest !== request || request.signal.aborted || !this.isConnected) return;
      this.dispatchEvent(new CustomEvent('listing:update-failed', { bubbles: true }));
      console.error('Collection filter request failed:', error);
    })
    .finally(() => {
       if (this.filterRequest === request) {
         this.filterRequest = null;
         this.hideLoader();
       }
       
    })
  }

}

customElements.define('collection-filters', Filters);



// ============= CALL BACK SCRIPT ON PAGE LOAD AND AJAX  ============= //
document.addEventListener('DOMContentLoaded', () => {
  initProductCardSliders();
});


/* ======================================================================
   LOCALIZATION FORM DROPDWON CODE
====================================================================== */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector('#currency_selector_form');
    this.languageForm = this.querySelector('#language_selector_form');

    this.currencyBtns = this.querySelectorAll('.currency_list button');
    this.languageBtns = this.querySelectorAll('.language_list button');
  }

  connectedCallback() {
    if(this.currencyBtns.length) {
      this.currencyBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCurrencyClick.bind(this));
      })
    }

    if(this.languageBtns.length) {
      this.languageBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleLanguageClick.bind(this));
      })
    }    
  }

  handleCurrencyClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="country_code"]').value = value;
    return;
    this.currencyForm.submit();
  }

  handleLanguageClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="language_code"]').value = value;
    return;
    this.languageForm.submit();
  }
}

customElements.define('localization-form', LocalizationForm);






/* ======================================================================
   RECENTLY VIEWED CODE
====================================================================== */
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'recently-viewed-products';
    this.sectionSelector = '[data-recently-viewed]';

    this.currentHandle = this.dataset.productHandle;
    this.maxProducts = Number(this.dataset.columns) || 4;
    this.aspectRatio = this.dataset.aspectRatio || 'portrait';
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
  }

  connectedCallback() {
    if (!this.currentHandle) return;

    this.updateRecentlyViewed();
    this.displayRecentlyViewedProducts();
  }

  updateRecentlyViewed() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    viewed = viewed.filter(handle => handle !== this.currentHandle);
    viewed.unshift(this.currentHandle);

    if (viewed.length > this.maxProducts) {
      viewed = viewed.slice(0, this.maxProducts);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(viewed));
  }

  async displayRecentlyViewedProducts() {
    const section = document.querySelector(this.sectionSelector);
    if (!section) return;

    const handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    if (!handles.length) {
      section.style.display = 'none';
      return;
    }

    try {
      const products = await Promise.all(
        handles.map(handle =>
          fetch(`${window.HOM_API_PATHS.productJsonBase}${handle}.js`).then(res => res.json())
        )
      );

      section.innerHTML = `
        <div class="recently_viewed_inner">
          ${products.map(product => this.renderProductCard(product)).join('')}
        </div>
      `;
    } catch (error) {
      console.error('Recently Viewed error:', error);
      section.style.display = 'none';
    }
  }

  renderProductCard(product) {
    if (!product) return '';

    const variant = product.variants[0];
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const hasSale = compareAt && compareAt > price;

    const image = product.images?.[0] || "";

    let ratio = 100;
    if (this.aspectRatio === 'portrait') ratio = 140;
    if (this.aspectRatio === 'square') ratio = 100;
    if (this.aspectRatio === 'adapt' && image) {
      ratio = 100;
    }

    return `
      <div class="recently_viewed_product">
        <div class="recently_viewed_product_img ratio" style="--aspect-ratio:${ratio}%">
          <a href="/products/${product.handle}" aria-label="${product.title}">
            ${window.HOMResponsiveMedia.imageMarkup(image, product.title)}
          </a>
        </div>

        <div class="recently_viewed_product_info">
          <p>
            <a aria-label="${product.title}" href="/products/${product.handle}">${product.title}</a>
          </p>

          <div class="recently_viewed_product_price">
            <span class="${hasSale ? 'sale_p' : 'regular'}">
              ${Shopify.formatMoney(price, this.moneyFormat)}
            </span>
            ${hasSale ? `<s>${Shopify.formatMoney(compareAt, this.moneyFormat)}</s>` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('recently-viewed', RecentlyViewed);

/* ======================================================================
   Composite Promotion Hub 
====================================================================== */
class PromoHub extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = -1;
  }

  connectedCallback() {
    this.blocks = [...this.querySelectorAll('.promo-hub-block')];
    this.backgrounds = [...this.querySelectorAll('.promo-hub-bg')];
    this.grid = this.querySelector('.promo-hub-grid');

    if (!this.blocks.length) return;

    /* Desktop interactions only */
    ['pointerover', 'focusin', 'mouseleave', 'keydown'].forEach((type) =>
      this.addEventListener(type, this)
    );

    /* Mobile: activate slide only after user scrolls */
    this.grid?.addEventListener(
      'scroll',
      () => {
        if (!this.isMobile()) return;

        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.setActiveSlide(), 60);
      },
      { passive: true }
    );
  }

  isMobile() {
    return window.innerWidth <= 749;
  }

  handleEvent(event) {
    const block = event.target.closest('.promo-hub-block');

    /* Disable hover/focus behavior on mobile */
    if (this.isMobile() && event.type !== 'keydown') return;

    if (event.type === 'mouseleave') {
      this.reset();
      return;
    }

    if (event.type === 'keydown') {
      this.onKeyDown(event, block);
      return;
    }

    if (block && this.contains(block)) {
      this.activate(this.blocks.indexOf(block));
    }
  }

  onKeyDown(event, block) {
    if (!block) return;

    if (event.key === 'Escape') {
      this.reset();
      block.blur();
      return;
    }

    const move = {
      ArrowRight: 1,
      ArrowLeft: -1,
      ArrowDown: 1,
      ArrowUp: -1
    }[event.key];

    if (!move) return;

    const current = this.blocks.indexOf(block);
    const next = current + move;

    if (next < 0 || next >= this.blocks.length) return;

    event.preventDefault();
    this.blocks[next].focus();

    if (this.isMobile()) {
      this.blocks[next].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  activate(index) {
    if (index < 0 || index === this.activeIndex) return;

    this.activeIndex = index;
    this.classList.add('has-hover');

    this.blocks.forEach((block, i) => {
      const active = i === index;

      block.classList.toggle('is-active', active);
      block.setAttribute('aria-current', active ? 'true' : 'false');

      this.backgrounds[i]?.classList.toggle('is-active', active);
    });
  }

  setActiveSlide() {
    if (!this.grid || !this.blocks.length) return;

    const gridRect = this.grid.getBoundingClientRect();
    const center = gridRect.left + gridRect.width / 2;

    let closestIndex = 0;
    let minDistance = Infinity;

    this.blocks.forEach((block, index) => {
      const rect = block.getBoundingClientRect();
      const blockCenter = rect.left + rect.width / 2;
      const distance = Math.abs(center - blockCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    this.activate(closestIndex);
  }

  reset() {
    /* Desktop only reset */
    if (this.isMobile()) return;

    this.activeIndex = -1;
    this.classList.remove('has-hover');

    this.blocks.forEach((block, i) => {
      block.classList.remove('is-active');
      block.setAttribute('aria-current', 'false');

      /* Keep first background visible */
      this.backgrounds[i]?.classList.toggle('is-active', i === 0);
    });
  }
}

if (!customElements.get('promo-hub')) {
  customElements.define('promo-hub', PromoHub);
}

/* ======================================================================
   Scrolling Image Text
====================================================================== */
class ScrollingImageText extends HTMLElement {
  constructor() { super(); this.curr = this.targ = 0; }

  connectedCallback() {
    this.setup = { start:1.1, end: 0.4, back: 0.4, smooth: 0.020 };
       // Start 1.0 = starts at bottom of screen. Increase to start earlier.
       // End 0.0 = finishes at top of screen. Decrease to finish later.
       // back Amount of "overshoot" bounce. 0.1 is subtle, 0.3 is bouncy.
       // smooth Inertia/Smoothness. 0.03 is very heavy/fluid, 0.1 is fast.
    this.init();
    this.obs = new IntersectionObserver(e => {
      this.active = e[0].isIntersecting;
      if (this.active) { this.snap = true; this.render(); }
    });
    this.obs.observe(this);
  }

  init() {
    this.querySelectorAll('[data-parallax-x], [data-parallax-rotate]').forEach(el => {
      if (el.dataset.parallaxX) el.style.setProperty('--parallax-x', el.dataset.parallaxX);
      if (el.dataset.parallaxRotate) el.style.setProperty('--parallax-rotate', el.dataset.parallaxRotate);
    });
  }

  render() {
    if (!this.active) return;

    const rect = this.getBoundingClientRect();
    const winH = window.innerHeight;
    const startPoint = winH * this.setup.start;
    const endPoint = winH * this.setup.end;
    
    // Calculate progress
    this.targ = Math.min(Math.max((startPoint - rect.top) / (startPoint - endPoint), 0), 1);
    
    // Smooth or Snap
    this.curr = this.snap ? this.targ : this.curr + (this.targ - this.curr) * this.setup.smooth;
    this.snap = false;

    // Apply Easing (Overshoot)
    const c1 = this.setup.back;
    const eased = 1 + (c1 + 1) * Math.pow(this.curr - 1, 3) + c1 * Math.pow(this.curr - 1, 2);

    this.style.setProperty('--parallax-progress', eased);
    requestAnimationFrame(() => this.render());
  }

  disconnectedCallback() { if (this.obs) this.obs.disconnect(); }
}

if (!customElements.get('scrolling-image-text')) {
  customElements.define('scrolling-image-text', ScrollingImageText);
}

/* ======================================================================
   Back in stock notification
   ====================================================================== */
function isAppsScriptMessage(event) {
  try {
    const host = new URL(event.origin).hostname;
    return host === 'script.googleusercontent.com' ||
      host.endsWith('.script.googleusercontent.com') ||
      host.endsWith('-script.googleusercontent.com');
  } catch (error) {
    return false;
  }
}

function setBackInStockState(panel, state) {
  panel.dataset.notificationState = state;
  const intro = panel.querySelector('.back-in-stock-intro');
  const form = panel.querySelector('.back-in-stock-form');
  const checking = panel.querySelector('[data-notification-checking]');
  const subscribed = panel.querySelector('[data-notification-subscribed]');
  const success = panel.querySelector('[data-notification-success]');
  const error = panel.querySelector('[data-notification-error]');
  const description = panel.querySelector('[data-notification-description] span');
  const email = form?.querySelector('input[name="email"]')?.value || '';
  const isConfirmationState = state === 'subscribed' || state === 'success';

  if (intro) intro.hidden = isConfirmationState;
  if (form) form.hidden = state !== 'eligible';
  if (checking) checking.hidden = state !== 'checking';
  if (subscribed) subscribed.hidden = state !== 'subscribed';
  if (success) success.hidden = state !== 'success';
  if (error) error.hidden = state !== 'error';

  if (description && email) {
    const descriptions = {
      checking: `Checking notification status for ${email}…`,
      eligible: `We'll notify ${email} when this item is back in stock.`,
      subscribed: `A restock notification is already active for ${email}.`,
      success: `Your restock notification is confirmed for ${email}.`,
      error: `We couldn't verify the notification status for ${email}.`
    };
    if (descriptions[state]) description.textContent = descriptions[state];
  }
}

function setBackInStockButtonLoading(button, loading) {
  if (!button) return;
  const label = button.querySelector('[data-notification-button-label]');
  const spinner = button.querySelector('[data-notification-button-spinner]');

  if (label && !button.dataset.defaultLabel) button.dataset.defaultLabel = label.textContent.trim();
  if (label) label.textContent = loading ? 'Submitting…' : button.dataset.defaultLabel;
  if (spinner) spinner.hidden = !loading;
  button.disabled = loading;
  button.setAttribute('aria-busy', String(loading));
}

function checkBackInStockStatus(panel) {
  if (!panel || panel.hidden || panel.dataset.customerLoggedIn !== 'true') return;

  const form = panel.querySelector('.back-in-stock-form');
  const frame = panel.querySelector('[data-notification-status-frame]');
  const customerId = form?.querySelector('[data-notification-customer]')?.value;
  const variantId = form?.querySelector('[data-notification-variant]')?.value;
  if (!form || !frame || !customerId || !variantId) return;

  const requestId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  panel.dataset.statusRequestId = requestId;
  setBackInStockState(panel, 'checking');

  const timeout = window.setTimeout(() => {
    window.removeEventListener('message', handleStatus);
    if (panel.dataset.statusRequestId === requestId) setBackInStockState(panel, 'error');
  }, 10000);

  function handleStatus(event) {
    if (!isAppsScriptMessage(event)) return;
    if (event.data?.type !== 'back-in-stock-response' || event.data.requestId !== requestId) return;

    window.clearTimeout(timeout);
    window.removeEventListener('message', handleStatus);
    if (panel.dataset.statusRequestId !== requestId) return;
    if (!event.data.ok) {
      setBackInStockState(panel, 'error');
      return;
    }
    setBackInStockState(panel, event.data.subscribed ? 'subscribed' : 'eligible');
  }

  window.addEventListener('message', handleStatus);
  const statusUrl = new URL(form.action);
  statusUrl.searchParams.set('action', 'status');
  statusUrl.searchParams.set('customer_id', customerId);
  statusUrl.searchParams.set('variant_id', variantId);
  statusUrl.searchParams.set('request_id', requestId);
  frame.src = statusUrl.toString();
}

function initializeBackInStockStatus(root = document) {
  root.querySelectorAll('[data-back-in-stock]').forEach(checkBackInStockStatus);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeBackInStockStatus());
} else {
  initializeBackInStockStatus();
}
document.addEventListener('shopify:section:load', (event) => initializeBackInStockStatus(event.target));
document.addEventListener('click', (event) => {
  const retry = event.target.closest('[data-notification-retry]');
  if (retry) checkBackInStockStatus(retry.closest('[data-back-in-stock]'));
});

document.addEventListener('submit', function (event) {
  const form = event.target.closest('.back-in-stock-form');
  if (!form) return;
  if (form.dataset.submitting === 'true') {
    event.preventDefault();
    return;
  }

  const panel = form.closest('[data-back-in-stock]');
  const submitButton = form.querySelector('button[type="submit"]');
  const frame = panel?.querySelector('[data-notification-submit-frame]');
  const requestIdInput = form.querySelector('input[name="request_id"]');

  form.querySelector('.back-in-stock-error')?.remove();
  if (!form.action || !frame || !requestIdInput || !submitButton) {
    event.preventDefault();
    form.insertAdjacentHTML('afterbegin', '<p class="back-in-stock-error" role="alert">Notifications are not configured yet. Please try again later.</p>');
    return;
  }

  form.dataset.submitting = 'true';
  form.setAttribute('aria-busy', 'true');
  setBackInStockButtonLoading(submitButton, true);
  const requestId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const submittedVariantId = form.querySelector('[data-notification-variant]')?.value || '';
  requestIdInput.value = requestId;

  const finishWithError = () => {
    const currentVariantId = form.querySelector('[data-notification-variant]')?.value || '';
    if (currentVariantId !== submittedVariantId) {
      setBackInStockButtonLoading(submitButton, false);
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      checkBackInStockStatus(panel);
      return;
    }

    setBackInStockState(panel, 'eligible');
    form.querySelector('.back-in-stock-error')?.remove();
    form.insertAdjacentHTML(
      'afterbegin',
      '<p class="back-in-stock-error" role="alert">We couldn’t submit your request. Please try again.</p>'
    );
    setBackInStockButtonLoading(submitButton, false);
    form.dataset.submitting = 'false';
    form.removeAttribute('aria-busy');
  };

  const timeout = window.setTimeout(() => {
    window.removeEventListener('message', handleResponse);
    finishWithError();
  }, 15000);

  function handleResponse(responseEvent) {
    if (!isAppsScriptMessage(responseEvent)) return;
    if (responseEvent.data?.type !== 'back-in-stock-response') return;
    if (responseEvent.data.requestId !== requestId) return;

    window.clearTimeout(timeout);
    window.removeEventListener('message', handleResponse);
    if (!responseEvent.data.ok) {
      finishWithError();
      return;
    }

    const currentVariantId = form.querySelector('[data-notification-variant]')?.value || '';
    if (currentVariantId !== submittedVariantId) {
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      setBackInStockButtonLoading(submitButton, false);
      checkBackInStockStatus(panel);
      return;
    }

    form.dataset.subscribedVariant = submittedVariantId;
    form.dataset.submitting = 'false';
    form.removeAttribute('aria-busy');
    setBackInStockButtonLoading(submitButton, false);
    setBackInStockState(panel, 'success');
  }

  window.addEventListener('message', handleResponse);
});
